
// Translation Dictionary
export const translations = {
    'en': {
        'Notice Welcome': 'Welcome to Romeo Alpha Maritime Consultants and Logistics International Ltd',
        'Home': 'Home',
        'About us': 'About us',
        'Operations': 'Operations',
        'Our fleets': 'Marketplace',
        'Marketplace': 'Marketplace',
        'Our team': 'Our team',
        'Careers': 'Careers',
        'Contact us': 'Contact us',
        'Get Quotes': 'Get Quotes',
        'Hero Heading': 'Powering Maritime Transportation and Offshore Operations',
        'Hero Subheading': 'Delivering safe and reliable shipping, marine security escort services, and offshore oil and gas support across coastal and international waters',
        'Browse Operations': 'Browse our operations',
        // Quick Links
        'Quick Marine Title': 'Marine Equipment and Vessels',
        'Quick Marine Desc': 'Browse our extensive inventory of marine equipment and vessels for sale. From tugboats to offshore support vessels, find quality maritime assets.',
        'Quick Marine Btn': 'Buy Now',
        'Quick Repair Title': 'Repairs and Scrap Sales',
        'Quick Repair Desc': 'Professional vessel repair services and scrap metal sales. We handle everything from minor repairs to complete vessel recycling and disposal.',
        'Quick Repair Btn': 'Repair Now',
        'Quick Construction Title': 'Marine Structure Construction',
        'Quick Construction Desc': 'Expert construction of marine infrastructure including docks, piers, jetties, and offshore platforms. Engineered for durability and safety.',
        'Quick Construction Btn': 'Build Now',
        'Quick Servicing Title': 'Oil Rig and Platform Servicing',
        'Quick Servicing Desc': 'Comprehensive servicing and maintenance for oil rigs and offshore platforms. 24/7 support with certified technicians and equipment.',
        'Quick Servicing Btn': 'Service Now',
        'Content Heading': 'Our Shipping and Logistics Solutions for every needs',
        'Content Subtext': 'We provide integrated maritime transportation and offshore support services. From cargo shipping to vessel management, we offer safe, efficient, and reliable solutions.',
        'Banner Heading': 'Let’s Do Business Together',
        'Banner Subtext': 'Partner with us on all maritime transportation, operations and security solution across coastal and international waters worldwide.',
        'Banner Button': 'Partner with us today',
        // Benefit Section
        'Why Romeo Alpha': 'Why Romeo Alpha?',
        'Why Subtext': 'We deliver reliable maritime and offshore solutions grounded in experience, safety, and long-term partnerships.',
        'Benefit 1 Title': 'Proven Maritime Expertise',
        'Benefit 1 Desc': 'Our operations are led by seasoned maritime professionals with deep knowledge of shipping, offshore logistics, and vessel operations across diverse environments.',
        'Benefit 2 Title': 'Reliable and Safe Operations',
        'Benefit 2 Desc': 'Safety and reliability are at the core of everything we do. We operate in full compliance with international maritime standards to protect assets, crew, and cargo.',
        'Benefit 3 Title': 'End-to-End Offshore Support',
        'Benefit 3 Desc': 'From vessel chartering and cargo transportation to offshore rig support and marine security escort, we provide integrated solutions under one trusted partner.',
        'Benefit 4 Title': 'Global Reach, Local Insight',
        'Benefit 4 Desc': 'We support operations in coastal and international waters, combining global operational reach with strong regional understanding and partnerships.',
        'Benefit 5 Title': 'Flexible and Scalable Solutions',
        'Benefit 5 Desc': 'Our services are tailored to your operational needs—whether for short-term assignments or long-term maritime and offshore contracts.',
        'Benefit 6 Title': 'Partnership-Oriented Approach',
        'Benefit 6 Desc': 'We work closely with clients, vessel owners, and stakeholders to build long-term partnerships that deliver operational efficiency and sustained value.',
        // Service Section
        'Services Heading': 'Our Services',
        'Services Subheading': 'We deliver comprehensive maritime, offshore, and logistics solutions tailored to the needs of vessel owners and operators.',
        'Service 1 Title': 'Ship Management',
        'Service 1 Desc': 'Our target is to provide competent, safe, and cost-effective services based on client-specific requirements.',
        'Service 2 Title': 'Vessel Survey and Inspections',
        'Service 2 Desc': 'We take the time to understand our customers\' needs and put the right people on the job.',
        'Service 3 Title': 'Brokerage Services',
        'Service 3 Desc': 'Our ship brokerage arm has proven track records of providing an unrivalled level of service for ship owners.',
        'Service 4 Title': 'Chartering',
        'Service 4 Desc': 'Our vessel chartering team can find the precise vessel, in the exact location, and at the correct time to fulfill destination needs.',
        'Service 5 Title': 'Sales of Scrap Vessels',
        'Service 5 Desc': 'Our extensive knowledge and track record in the local and international scrap market make us the ideal sales representation.',
        'Service 6 Title': 'Crewing',
        'Service 6 Desc': 'We provide suitably qualified crew for vessels in accordance with current standards and international conventions.',
        'Service 7 Title': 'Bunkering',
        'Service 7 Desc': 'Our company has the requisite capacity to offer marine fueling and bunkering at major ports.',
        'Service 8 Title': 'Project Management and Operations',
        'Service 8 Desc': 'We ensure projects are handled through a structured approach with appropriate resources, tools, and equipment.',
        'Service 9 Title': 'Marine Security',
        'Service 9 Desc': 'Romeo Alpha provides comprehensive maritime security solutions, including vessel escort, armed guards, and risk assessment.',
        'Service 10 Title': 'General Marine',
        'Service 10 Desc': 'Our General Marine Services aim to provide safe, efficient, and reliable maritime solutions.',
        'Overlay Maritime': 'Maritime Transportation<br>and Operation',
        'Overlay Charter': 'Vessel Chartering &<br>Management',
        'Overlay Offshore': 'Offshore &<br>Oil Field Support',
        'Overlay Security': 'Marine Security<br>Escort',
        'Overlay Repair': 'Vessel Repair<br>and Scrap Sales',
        'Explore Service': 'Explore Service',
        // Ads Section
        'Ads Heading': 'Romeo Alpha has got you covered',
        'Ads Subtext': 'Need reliable shipping? Offshore support on short notice? Security escort for critical cargo?<br>Romeo Alpha delivers trusted maritime solutions across coastal and international waters.',
        'Tag Marine': 'Maritime Transportation',
        'Tag Offshore': 'Offshore Support',
        'Tag Charter': 'Vessel Charter',
        'Tag Security': 'Marine Security Escort',
        'Tag Logistics': 'Oil and Gas Logistics',
        'Tag Global': 'Global Operations',
        'FAQ Title': 'Frequently Asked Questions',
        // FAQ Section
        'FAQ_Q1': 'What maritime services does Romeo Alpha offer?',
        'FAQ_A1': 'Romeo Alpha provides comprehensive maritime services including vessel chartering, offshore support, marine security escort services, ship brokerage, cargo logistics, fleet management, and oil & gas offshore operations across coastal and international waters.',
        'FAQ_Q2': 'What areas do you operate in?',
        'FAQ_A2': 'We operate globally across major shipping routes and offshore locations. Our primary coverage includes West African waters, the Gulf of Guinea, Mediterranean Sea, and international shipping lanes connecting Africa, Europe, and the Americas.',
        'FAQ_Q3': 'How do I request a quote for your services?',
        'FAQ_A3': 'You can request a quote by clicking the "Get Quotes" button on our website, contacting us via email, or calling our 24/7 operations center. Our team typically responds within 24 hours with a detailed proposal tailored to your specific requirements.',
        'FAQ_Q4': 'What types of vessels are in your fleet?',
        'FAQ_A4': 'Our fleet includes offshore support vessels (OSVs), anchor handling tugs (AHTS), platform supply vessels (PSVs), crew boats, tugboats, and security escort vessels. All vessels are modern, well-maintained, and comply with international maritime standards.',
        'FAQ_Q5': 'Do you provide 24/7 operational support?',
        'FAQ_A5': 'Yes, we maintain round-the-clock operations with our dedicated support team available 24/7. Our operations center monitors all active vessels and can respond to emergencies or schedule changes at any time.',
        'FAQ_Q6': 'What safety certifications do you hold?',
        'FAQ_A6': 'Romeo Alpha holds ISM Code certification, ISO 9001:2015 for quality management, and complies with SOLAS, MARPOL, and ISPS Code requirements. Our crews are certified according to STCW standards and undergo regular safety training.',
        'FAQ_Q7': 'How can I partner with Romeo Alpha?',
        'FAQ_A7': 'We welcome partnerships with shipping companies, oil & gas operators, and maritime service providers. Contact our business development team through our Contact page to discuss collaboration opportunities and strategic alliances.',
        // New Keys (English)
        'Proof Vessels': '150+',
        'Proof Vessels Text': 'Active and Managed Vessels',
        'Proof Countries': '50+',
        'Proof Countries Text': 'Countries Served Across Global Waters',
        'Proof Support': '24/7',
        'Proof Support Text': 'Marine and Offshore Operations Support',
        'Footer Subscribe Heading': 'Subscribe to our newsletter',
        'Footer Subscribe Btn': 'Subscribe',
        'Footer Business Heading': 'Doing Business Together',
        'Footer Link What': 'What we do',
        'Footer Link Fleets': 'Marketplace',
        'Footer Link Offshore': 'Offshore services',
        'Footer Link Security': 'Marine security',
        'Footer Link Charter': 'Vessel charter and management',
        'Footer Link Partnership': 'Partnerships',
        // Admin Login
        'Admin Login': 'Admin Login',
        'Secure Access': 'Enter your credentials to access the dashboard',
        'Email Address': 'Email Address',
        'Password': 'Password',
        'Login': 'Login',
        'Footer Know Heading': 'Get to know Us',
        'Footer Link About': 'About Romeo Alpha',
        'Footer Link News': 'News and Insights',
        'Footer Link Careers': 'Careers',
        'Footer Link Contact': 'Contact us',
        'Footer Address': 'Headquarters - +2348066184330 / +2348055769660 - info@romeoalphamaritime.com / Kyoyan99@yahoo.com - No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'CAC Registration': 'RC: 9257242 - Registered with the Corporate Affairs Commission (CAC)',
        'Scroll Top': 'Top',
        'Unread': 'Unread',
        // About Page
        'About Hero Title': 'About Romeo Alpha',
        'About Hero Subtitle': 'Leading the way in global maritime solutions and offshore excellence.',
        'Mission Title': 'Our Mission',
        'Mission Text': 'To provide safe, reliable, and efficient maritime transportation and offshore support services that exceed client expectations while maintaining the highest standards of safety and environmental stewardship.',
        'Vision Title': 'Our Vision',
        'Vision Text': 'To be the preferred global partner in the maritime industry, recognized for our commitment to excellence, innovation, and sustainable growth.',
        'Who We Are Title': 'Who We Are',
        'Who We Are Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd is a premier provider of marine transportation and offshore support services. With a fleet of modern vessels and a team of seasoned professionals, we operate across coastal and international waters to deliver critical support to the oil and gas industry and general maritime commerce.',
        'Who We Are Desc 2': 'Founded on the principles of integrity and safety, we have grown into a trusted name in the industry, handling complex logistics, high-value asset protection, and vessel management with precision and care.',
        'Stat Years': '10+',
        'Stat Years Label': 'Years Experience',
        'Stat Vessels': '150+',
        'Stat Vessels Label': 'Vessels Managed',
        'Stat Partners': '50+',
        'Stat Partners Label': 'Global Partners',
        'Get in touch': 'Get in touch',
        // Fleets Page
        'Fleets Hero Title': 'Our Global Fleet',
        'Fleets Hero Subtitle': 'A versatile and modern fleet designed for safety, efficiency, and global reach.',
        'Fleet Overview Title': 'Fleet Overview',
        'Fleet Overview Desc': 'Romeo Alpha manages a diverse portfolio of vessels, ranging from large-scale cargo carriers to specialized offshore support units. Our commitment to maintenance excellence ensures high availability and operational reliability for our clients worldwide.',
        'Total Vessels': 'Total Vessels',
        'Vessel Types': 'Vessel Types',
        'Avg Age': 'Average Age',
        'Cat Offshore': 'Offshore Support Vessels',
        'Cat Cargo': 'Cargo and Tanker Fleet',
        'View Spec': 'View Specs',
        // Team Page
        'Team Hero Title': 'Meet Our Leaders',
        'Team Hero Subtitle': 'The experienced professionals driving maritime excellence.',
        'Team Intro': 'At Romeo Alpha, our success is built on the expertise, dedication, and leadership of our people. Our management team combines decades of international maritime experience with a forward-thinking approach to operations and logistics.',
        'Founder Label': 'FOUNDER and VISIONARY',
        'MD Label': 'MANAGING DIRECTOR',
        'Core Team Title': 'Core Leadership Team',
        'Join Team Title': 'Want to join our crew?',
        'Join Team Subtitle': 'We are always looking for talented individuals to join our growing family.',
        'See Openings': 'See Career Openings',
        // Additional Keys
        'Ans Header': 'Ans.',
        'FAQ Header': 'FAQs.',
        'Search Placeholder': 'Search for a service...',
        'Category All': 'All Services',
        'Category Offshore': 'For Sale',
        'Category Logistics': 'For Hire',
        'Category Charter': 'Repair',
        'Category Port': 'Scraps',
        'Marketplace Sale': 'For Sale',
        'Marketplace Hire': 'For Hire',
        'Marketplace Repair': 'Repair',
        'Marketplace Scrap': 'Scraps',
        'No Results': 'No results found.',
        'Operations Page Title': 'Marine Marketplace',
        'Operations Page Subtitle': 'Explore vessels for sale, for hire, repairs and scraps.',
        'Contact Hero Title': 'Get in Touch',
        'Contact Hero Subtitle': 'We are here to help you with your maritime and offshore needs.',
        'Visit Office Heading': 'Visit Our Office',
        'Lets Talk Heading': 'Let\'s Talk',
        'Call Us CTA': 'Call Us',
        'Inbox Heading': 'Inbox',
        'Email Us CTA': 'Send E-mail',
        'Support Text': 'Get in touch and let us know how we can help.',
        'About Btn': 'About Company',
        'Form Title': 'Send us a message',
        'Form Name': 'Full Name',
        'Form Email': 'Email Address',
        'Form Subject': 'Subject',
        'Form Message': 'Message',
        'Form Submit': 'Send Message',
        'Careers Hero Title': 'Join Our Team',
        'Careers Hero Subtitle': 'Build your future with a global leader in maritime excellence.',
        'Careers Label': 'CAREERS',
        'Working Title': 'Working at Romeo Alpha',
        'Working P1': 'At Romeo Alpha, our people are the foundation of our success. We provide a supportive environment where maritime professionals can grow, contribute meaningfully, and operate to the highest international standards.',
        'Working P2': 'We pride ourselves on our commitment to safety, professionalism, and the well-being of our crew and staff. Joining us means becoming part of a family that values expertise and dedication.',
        'Get In Touch': 'Get in Touch',
        'Recruitment Title': 'Recruitment',
        'Recruitment P1': 'Our recruitment process is structured to identify the best talent in the industry. As an equal opportunity employer, we focus on quality, competence, and integrity across all our marine, offshore, logistics, and technical roles.',
        'Recruitment P2': 'We are constantly on the lookout for individuals who share our vision for excellence and innovation. If you are ready to take your career to the next level, we want to hear from you.',
        'Related Subtitle': 'explore other services',
        // Common UI & SEO
        'Logo Alt': 'Company Logo',
        'Email Placeholder': 'Email',
        'Copyright': '© 2026 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        // SEO Metadata
        'SEO Home Title': 'Vessel Shipping, Offshore Support & Marine Escort',
        'SEO Home Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd provides ship chartering, offshore support, marine security escort, vessel repairs and scrap sales globally.',
        'SEO Home Keywords': 'maritime, shipping, offshore oil and gas support, security escort vessel, vessel chartering, ship management, marine consultancy',
        'SEO About Title': 'About Us - Global Maritime Logistics Specialists',
        'SEO About Desc': 'Learn about Romeo Alpha Maritime, our mission, vision, fleet capacity, and commitment to global maritime transportation and offshore oil rig support.',
        'SEO About Keywords': 'about romeo alpha, marine crew, master mariner, marine consultants, offshore history, maritime compliance',
        'SEO Marketplace Title': 'Marine Marketplace - Vessels for Sale, Hire, & Scraps',
        'SEO Marketplace Desc': 'Explore our marine marketplace. Buy or hire offshore support vessels, tugboats, secure marine structures construction, vessel repairs, and scrap metal.',
        'SEO Marketplace Keywords': 'buy vessel, hire tugboat, marine scraps, vessel repair, oil rig servicing, boat construction',
        'SEO Team Title': 'Our Leadership Team - Experienced Master Mariners',
        'SEO Team Desc': 'Meet our leadership team including Captain Smart-Alli and Captain James Sterling, bringing decades of deep-sea navigation and maritime operations management.',
        'SEO Team Keywords': 'captain smart-alli, master mariner, maritime leaders, shipping management',
        'SEO Careers Title': 'Careers - Join Our Maritime and Offshore Team',
        'SEO Careers Desc': 'Build your future at Romeo Alpha. We offer rewarding career opportunities for qualified crew, offshore technicians, and maritime engineers.',
        'SEO Careers Keywords': 'maritime jobs, crewing, offshore careers, marine engineering, ship jobs',
        'SEO Contact Title': 'Contact Us - 24/7 Marine Operations Center',
        'SEO Contact Desc': 'Get in touch with Romeo Alpha Maritime. Request a quote or proposal for shipping, vessel chartering, marine security, or platform maintenance.',
        'SEO Contact Keywords': 'contact romeo alpha, request quote, marine support port harcourt, ship owner inquiries',
        'SEO Service Maritime Title': 'Maritime Transportation and Shipping Services',
        'SEO Service Maritime Desc': 'Safe and reliable marine transportation services across West African and international waters. Managing shipping logistics, dry and liquid cargo.',
        'SEO Service Maritime Keywords': 'cargo shipping, maritime transit, vessel transport, cargo shipping west africa',
        'SEO Service Charter Title': 'Vessel Chartering and Ship Management',
        'SEO Service Charter Desc': 'Tailored vessel chartering and ship management services. We match requirements to supply qualified crew, bunkering, and vessel inspections.',
        'SEO Service Charter Keywords': 'vessel charter, ship management, bunkering, vessel inspection, crewing',
        'SEO Service Offshore Title': 'Offshore & Oil Field Operations Support',
        'SEO Service Offshore Desc': 'Reliable support for offshore platforms, oil rig maintenance, oilfield logistics, anchor handling, and towing services.',
        'SEO Service Offshore Keywords': 'offshore support, oil rig servicing, oilfield logistics, anchor handling tug',
        'SEO Service Security Title': 'Marine Security Escort and Asset Protection',
        'SEO Service Security Desc': 'Comprehensive maritime security, armed escort vessels, and risk assessments for transit through high-risk offshore zones.',
        'SEO Service Security Keywords': 'marine security, armed escort vessel, maritime protection, risk assessment',
        // Service Details
        'Key Operations': 'Key Operations',
        'Other Services': 'Other Services',
        'Charter Operations': 'Charter Operations',
        'Offshore Operations': 'Offshore Support Operations',
        'Security Operations': 'Security Operations',
        'Armed Guards': 'Armed Guards',
        'Risk Assessment': 'Risk Assessment',
        // Partnership Form
        'Partnership Heading': 'Build with Romeo Alpha',
        'Partnership Subheading': 'Expand your maritime reach through a strategic alliance with our global network.',
        'Label Company': 'Company Name',
        'Label Representative': 'Contact Representative',
        'Label Email': 'Business Email',
        'Label Phone': 'Phone Number',
        'Label Interest': 'Service Area of Interest',
        'Label Message': 'Proposal / Message',
        'Placeholder Company': 'Enter your company name',
        'Placeholder Representative': 'Full name',
        'Placeholder Email': 'email@company.com',
        'Placeholder Phone': '+234...',
        'Partnership Placeholder Message': 'Describe your partnership vision...',
        'Option Shipping': 'Shipping and Logistics',
        'Option Technical': 'Marine Technical Services',
        'Option Security': 'Maritime Security',
        'Option Marketplace': 'Vessel Marketplace',
        'Option Other': 'Other Potential Alliance',
        'Partnership Success': 'Thank you! Our partnership team will contact you shortly.',
        'Partnership Btn': 'Send Partnership Proposal',
        'Sending': 'Sending...',
        // Contact Form
        'Form Success Alert': 'Thank you! Your message has been sent to our team and saved to the dashboard.',
        'Placeholder Name': 'John Doe',
        'Placeholder Subject': 'e.g. Inquiry regarding vessel',
        'Placeholder Message': 'Your message here...',
        // Marketplace
        'Interested CTA': 'Interested in reaching out',
        'Tag Available': 'Available',
        'Tag Marketplace': 'Marketplace',
        'Tag Featured': 'Featured',
        // Operation Detail
        'Expertise Heading': 'Our Expertise',
        'Expertise 1': 'Global operational reach',
        'Expertise 2': 'Safe and reliable navigation',
        'Expertise 3': 'Expertly maintained vessel fleet',
        'Expertise 4': 'Highly trained maritime professionals',
        'Inquiry Heading': 'Inquire About This Service',
        'Inquiry Placeholder Message': 'How can we assist you with this operation?',
        'Inquiry Submit': 'Submit Inquiry',
        'Images Left': 'images left',
        // Team Bios
        'CEO Name': 'Captain Smart-Alli',
        'CEO Title': 'Chief Executive Officer',
        'CEO Quote': '"Our journey is defined by the trust we build at sea and the excellence we deliver in every nautical mile."',
        'CEO Bio 1': 'Captain Smart-Alli has over three decades of offshore experience and expertise in maritime transportation and the oil & gas industry. With this visionary leadership, he established Romeo Alpha Maritime Consultants with a singular goal: to redefine excellence in offshore support and logistics.',
        'CEO Bio 2': 'Under his guidance, the company has grown into a premier regional power, known for its uncompromising commitment to safety and operational precision. His deep understanding of international maritime law has been instrumental in navigating complex global logistics challenges.',
        'James Name': 'Capt. James Sterling',
        'James Bio 1': 'Capt. James Sterling brings an unparalleled wealth of experience to our daily operations. A master mariner with over 25 years of experience in deep-sea navigation and maritime operations management, he overseas the strategic direction and safety protocols of our entire fleet.',
        'James Bio 2': 'His leadership ensures that every mission—from complex anchor handling to high-stakes marine security—is executed with the highest degree of professionalism and technical accuracy.',
        'Sarah Name': 'Sarah Okafor',
        'Sarah Bio': 'Expert in offshore logistics coordination and supply chain optimization across West Africa.',
        'David Name': 'Engr. David Chen',
        'Operational Leadership in Action': 'Operational Leadership in Action',
        'Operational Command': 'Operational Command',
        'Strategic Planning': 'Strategic Planning',
        'Technical Oversight': 'Technical Oversight',
        'Leadership & Heritage': 'Leadership & Heritage',
        'David Bio': 'Chief Engineer specializing in vessel maintenance, repair, and fleet technical compliance.',
        'Elena Name': 'Elena Rodriguez',
        'Elena Bio': 'Dedicated to maintaining world-class safety standards and environmental compliance.',
        'Marcus Name': 'Marcus Thorne',
        'Marcus Bio': 'Specializes in vessel deployment, crew management, and operational efficiency across global waters.',
        // Marketplace Detail & Listing
        'Marketplace Loading': 'Loading item details...',
        'Item Not Found': 'Item Not Found',
        'Item Error Desc': 'The marketplace item you\'re looking for doesn\'t exist or has been removed.',
        'Back to Marketplace': 'Back to Marketplace',
        'Item Description': 'Item Description',
        'Key Specifications': 'Key Specifications',
        'Label Category': 'Category:',
        'Label Location': 'Location:',
        'Label Area': 'Area:',
        'Label Badges': 'Labels:',
        'Immediate': 'Immediate',
        'Default Area': 'Port Harcourt, Nigeria',
        'Send Inquiry Detail': 'Send Inquiry',
        'Maritime Consultant': 'Maritime Consultant',
        'Consultant Ready': 'Ready to assist with your procurement.',
        'Back': 'Back',
        'Marketplace Featured': 'Featured',
        'Marketplace Available': 'Available',
        'Enquire': 'Enquire',
        'Reach out': 'Reach out',
        'Price': 'Price',
        'Service Help Text': 'Want to service oil rigs or Build house boat?',
        'See Details': 'See Details',
        // Admin Dashboard & Login Additionals
        'Admin Email Placeholder': 'admin@romeoalpha.com',
        'Access Denied': 'Access Denied: You do not have admin privileges.',
        'Verifying': 'Verifying...',
        'General Error': 'Something went wrong. Please try again.',
        'Dashboard Overview': 'Dashboard Overview',
        'Recent Activity': 'Recent Activity',
        'Active Listings': 'Active Listings',
        'Vessels for Sale': 'Vessels for Sale',
        'Marine Marketplace': 'Marine Marketplace',
        'Manage Vessels': 'Manage vessels for sale, hire, repair and scraps.',
        'Add New Item': 'Add New Item',
        'Edit Marketplace Item': 'Edit Marketplace Item',
        'Save Item': 'Save Item',
        'Update Item': 'Update Item',
        'Cancel': 'Cancel',
        'Title': 'Title',
        'Category': 'Category',
        'Price Placeholder': 'e.g. ₦1,200,000 or Contact for Price',
        'Vessel Status': 'Status',
        'Vessel Area': 'Area',
        'Description': 'Description',
        'Badges Placeholder': 'e.g. Support, Offshore, Rig Move',
        'Upload Images': 'Upload Images (Max 5)',
        'Item Added Success': 'Item added successfully!',
        'Item Updated Success': 'Item updated successfully!',
        'Delete Confirm': 'Are you sure you want to delete this item?',
        'Newsletter Hub': 'Newsletter Hub',
        'Subscriber List': 'View and manage your subscriber list',
        'Refresh List': 'Refresh List',
        'Subscriber Email': 'Subscriber Email',
        'Joined Date': 'Joined Date',
        'Actions': 'Actions',
        'Remove Subscriber': 'Remove subscriber from list?',
        'FAQ Management': 'FAQ Management',
        'Add New FAQ': 'Add New FAQ',
        'Question': 'Question',
        'Answer': 'Answer',
        'Save FAQ': 'Save FAQ',
        'Update FAQ': 'Update FAQ',
        'FAQ Delete Confirm': 'Are you sure you want to delete this FAQ?',
        'Dashboard': 'Dashboard',
        'Newsletter': 'Newsletter',
        'Logout': 'Logout',
        'Admin User': 'Admin User',
        'Administrator': 'Administrator',
        'Headquarters': 'Headquarters',
        'Messages': 'Messages',
        'Manage Messages': 'View and manage incoming contact messages',
        'No Messages': 'No messages found.',
        'View Message': 'View Message',
        'Mark as Read': 'Mark as Read',
        'Mark as Unread': 'Mark as Unread',
        'No Subject': 'No Subject',
        'Received Date': 'Received Date',
        // Upload / Ads Management
        'Upload': 'Advertisements',
        'Upload Image': 'Upload New Ad',
        'Upload New Ad Image': 'Upload Advertisement Banner',
        'Select Image': 'Select Image File',
        'Uploading': 'Uploading...',
        'Save Ad': 'Save Advertisement',
        'Ad Added Success': 'Advertisement added successfully!',
        'No Ads found': 'No advertisements found.',
        'Loading Ads': 'Loading Advertisements...',
        // Marketplace Inquiry
        'Submit Inquiry Title': 'Submit Inquiry',
        'Full Name': 'Full Name',
        'Inquiry Message': 'Inquiry Message',
        'Discussion Details': 'Details of Discussion',
        'Contact Person': 'Contact Person',
        'Sending Request': 'Sending Request...',
        'Inquiry Success': 'Inquiry sent successfully!',
        'Inquiry Error': 'Failed to send inquiry. Please try again.',
        'Close': 'Close',
        // Header/Footer & Misc
        'Language': 'Language',
        'Switch Language': 'Switch Language',
        'Explore Our Services': 'Explore Our Services',
        'Back to Home': 'Back to Home',
        'Role Head of Operations': 'Head of Operations',
        'Role Technical Director': 'Technical Director',
        'Label Portharcourt': 'No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'General Message Error': 'Failed to send message. Please try again later.',
        'Team Info Heading': 'Our Leadership',
        'Meet the Team': 'Meet our Leaders',
        'Lang English': 'English',
        'Lang Spanish': 'Español',
        'Lang French': 'Français',
        'Lang German': 'Deutsch',
        'Lang Chinese': '中文 (Chinese)',
        'Delete': 'Delete',
        'Error Label': 'Error',
        'Try Refresh': 'Try Refresh',
        'Files Selected': 'files selected',
        'NA': 'N/A',
        'Mass Delete Confirm': 'Are you sure you want to delete these items?',
        'Delete Success': 'Items deleted successfully',
        'Form Required Error': 'Title and Description are required',
        'FAQ Required Error': 'Question and Answer are required',
        'Marketplace Empty State': 'Marketplace items will appear here once you start adding them.',
        'FAQ Empty State': 'No FAQs found. Add one to get started.',
        'Newsletter Empty State': 'No subscribers found.',
        'File Size Error': 'File is too large',
    },
    'es': {
        'Notice Welcome': 'Bienvenido a Romeo Alpha Maritime Consultants and Logistics International Ltd',
        'Home': 'Inicio',
        'About us': 'Sobre nosotros',
        'Operations': 'Operaciones',
        'Our fleets': 'Mercado',
        'Marketplace': 'Mercado',
        'Our team': 'Nuestro equipo',
        'Careers': 'Carreras',
        'Contact us': 'Contáctenos',
        'Get Quotes': 'Solicitar presupuesto',
        'Hero Heading': 'Potenciando el transporte marítimo y las operaciones en alta mar',
        'Hero Subheading': 'Brindando servicios de envío seguros y confiables, escolta de seguridad marina y apoyo de petróleo y gas en alta mar en aguas costeras e internacionales',
        'Browse Operations': 'Explorar nuestras operaciones',
        // Quick Links
        'Quick Marine Title': 'Equipos y Buques Marinos',
        'Quick Marine Desc': 'Explore nuestro extenso inventario de equipos y buques marinos para la venta. Desde remolcadores hasta buques de apoyo en alta mar, encuentre activos marítimos de calidad.',
        'Quick Marine Btn': 'Comprar ahora',
        'Quick Repair Title': 'Reparaciones y ventas de chatarra',
        'Quick Repair Desc': 'Servicios profesionales de reparación de buques y venta de chatarra. Nos encargamos de todo, desde reparaciones menores hasta reciclaje y eliminación completa de buques.',
        'Quick Repair Btn': 'Reparar ahora',
        'Quick Construction Title': 'Construcción de Estructuras Marinas',
        'Quick Construction Desc': 'Construcción experta de infraestructura marina incluyendo muelles, muelles, escolleras y plataformas offshore.',
        'Quick Construction Btn': 'Construir ahora',
        'Quick Servicing Title': 'Servicio de Plataformas Petroleras',
        'Quick Servicing Desc': 'Servicio integral y mantenimiento para plataformas petroleras y plataformas offshore.',
        'Quick Servicing Btn': 'Servicio ahora',
        'Content Heading': 'Nuestras Soluciones de Transporte y Logística para cada necesidad',
        'Content Subtext': 'Brindamos servicios integrados de transporte marítimo y apoyo offshore. Desde el envío de carga hasta la gestión de buques.',
        'Banner Heading': 'Hagamos negocios juntos',
        'Banner Subtext': 'Asóciese con nosotros en todas las soluciones de transporte, operaciones y seguridad marítima en todo el mundo.',
        'Banner Button': 'Asóciese con nosotros hoy',
        // Benefit Section
        'Why Romeo Alpha': '¿Por qué Romeo Alpha?',
        'Why Subtext': 'Entregamos soluciones marítimas y offshore confiables basadas en la experiencia, la seguridad y las asociaciones a largo plazo.',
        'Benefit 1 Title': 'Experiencia Marítima Probada',
        'Benefit 1 Desc': ' Nuestras operaciones son dirigidas por profesionales marítimos experimentados con profundo conocimiento del transporte y la logística offshore.',
        'Benefit 2 Title': 'Operaciones Confiables y Seguras',
        'Benefit 2 Desc': 'La seguridad y la confiabilidad son el núcleo de todo lo que hacemos. Cumplimos plenamente con los estándares marítimos internacionales.',
        'Benefit 3 Title': 'Soporte Offshore Extremo a Extremo',
        'Benefit 3 Desc': 'Desde el fletamento de buques hasta el apoyo a plataformas offshore, ofrecemos soluciones integradas bajo un socio de confianza.',
        'Benefit 4 Title': 'Alcance Global, Perspectiva Local',
        'Benefit 4 Desc': 'Apoyamos operaciones en aguas costeras e internacionales, combinando el alcance operativo global con un fuerte entendimiento regional.',
        'Benefit 5 Title': 'Soluciones Flexibles y Escalables',
        'Benefit 5 Desc': 'Nuestros servicios se adaptan a sus necesidades operativas, ya sea para tareas a corto plazo o contratos a largo plazo.',
        'Benefit 6 Title': 'Enfoque Orientado a la Asociación',
        'Benefit 6 Desc': 'Trabajamos estrechamente con clientes y propietarios de buques para construir asociaciones a largo plazo que brinden eficiencia operativa.',
        // Service Section
        'Services Heading': 'Nuestros Servicios',
        'Services Subheading': 'Entregamos soluciones marítimas, offshore y logísticas integrales adaptadas a las necesidades de los propietarios y operadores de buques.',
        'Service 1 Title': 'Gestión de Buques',
        'Service 1 Desc': 'Nuestro objetivo es proporcionar servicios competentes, seguros y rentables basados en los requisitos específicos del cliente.',
        'Service 2 Title': 'Inspección y Peritaje de Buques',
        'Service 2 Desc': 'Nos tomamos el tiempo para entender las necesidades de nuestros clientes y ponemos a las personas adecuadas en el trabajo.',
        'Service 3 Title': 'Servicios de Corretaje',
        'Service 3 Desc': 'Nuestra rama de corretaje de buques tiene un historial probado de proporcionar un nivel de servicio inigualable.',
        'Service 4 Title': 'Fletamento',
        'Service 4 Desc': 'Nuestro equipo de fletamento de buques puede encontrar el buque preciso, en la posición exacta y en el momento correcto.',
        'Service 5 Title': 'Venta de Buques para Chatarra',
        'Service 5 Desc': 'Nuestro amplio conocimiento en el mercado local e internacional de chatarra nos convierte en el representante de ventas ideal.',
        'Service 6 Title': 'Tripulación',
        'Service 6 Desc': 'Proporcionamos tripulación debidamente cualificada para los buques de acuerdo con los estándares actuales y convenciones internacionales.',
        'Service 7 Title': 'Suministro de Combustible',
        'Service 7 Desc': 'Nuestra empresa tiene la capacidad necesaria para ofrecer abastecimiento de combustible marino en los principales puertos.',
        'Service 8 Title': 'Gestión de Proyectos y Operaciones',
        'Service 8 Desc': 'Aseguramos que los proyectos se manejen a través de un enfoque estructurado con los recursos y herramientas adecuados.',
        'Service 9 Title': 'Seguridad Marina',
        'Service 9 Desc': 'Romeo Alpha ofrece soluciones integrales de seguridad marítima, incluyendo escolta de buques, guardias armados y evaluación de riesgos.',
        'Service 10 Title': 'Marina General',
        'Service 10 Desc': 'Nuestros Servicios de Marina General tienen como objetivo proporcionar soluciones marítimas seguras, eficientes y confiables.',
        'Overlay Maritime': 'Transporte Marítimo<br>y Operación',
        'Overlay Charter': 'Fletamento y Gestión<br>de Buques',
        'Overlay Offshore': 'Apoyo Offshore y<br>Campos Petrolíferos',
        'Overlay Security': 'Escolta de<br>Seguridad Marina',
        'Overlay Repair': 'Reparación de Buques<br>y Venta de Chatarra',
        'Explore Service': 'Explorar servicio',
        // Ads Section
        'Ads Heading': 'Romeo Alpha lo tiene cubierto',
        'Ads Subtext': '¿Necesita envío confiable? ¿Apoyo offshore a corto plazo? Romeo Alpha ofrece soluciones marítimas de confianza.',
        'Tag Marine': 'Transporte Marítimo',
        'Tag Offshore': 'Apoyo Offshore',
        'Tag Charter': 'Fletamento de Buques',
        'Tag Security': 'Escolta de Seguridad Marina',
        'Tag Logistics': 'Logística de Petróleo y Gas',
        'Tag Global': 'Operaciones Globales',
        'FAQ Title': 'Preguntas Frecuentes',
        // FAQ Section
        'FAQ_Q1': '¿Qué servicios marítimos ofrece Romeo Alpha?',
        'FAQ_A1': 'Romeo Alpha ofrece servicios marítimos integrales que incluyen fletamento de buques, apoyo offshore, servicios de escolta de seguridad marina, corretaje de buques, logística de carga, gestión de flotas y operaciones de petróleo y gas en aguas costeras e internacionales.',
        'FAQ_Q2': '¿En qué áreas operan?',
        'FAQ_A2': 'Operamos globalmente en las principales rutas de navegación y ubicaciones offshore. Nuestra cobertura principal incluye aguas de África Occidental, el Golfo de Guinea, el Mar Mediterráneo y las rutas internacionales que conectan África, Europa y las Américas.',
        'FAQ_Q3': '¿Cómo solicito un presupuesto para sus servicios?',
        'FAQ_A3': 'Puede solicitar un presupuesto haciendo clic en el botón "Solicitar presupuesto", por correo electrónico o llamando a nuestro centro de operaciones las 24 horas del día. Nuestro equipo responde normalmente en 24 horas.',
        'FAQ_Q4': '¿Qué tipos de buques hay en su flota?',
        'FAQ_A4': 'Nuestra flota incluye buques de apoyo offshore (OSV), remolcadores de manejo de anclas (AHTS), buques de suministro de plataformas (PSV), lanchas de tripulación y buques de escolta de seguridad. Todos cumplen con los estándares internacionales.',
        'FAQ_Q5': '¿Ofrecen soporte operativo las 24 horas, los 7 días de la semana?',
        'FAQ_A5': 'Sí, mantenemos operaciones las 24 horas con un equipo de soporte dedicado. Nuestro centro de operaciones monitorea todos los buques activos y puede responder a emergencias en cualquier momento.',
        'FAQ_Q6': '¿Qué certificaciones de seguridad tienen?',
        'FAQ_A6': 'Romeo Alpha cuenta con la certificación del Código IGS (ISM), ISO 9001:2015 para la gestión de calidad, y cumple con los requisitos de SOLAS, MARPOL y el Código PBIP (ISPS).',
        'FAQ_Q7': '¿Cómo puedo asociarme con Romeo Alpha?',
        'FAQ_A7': 'Agradecemos las asociaciones con compañías navieras, operadores de petróleo y gas y proveedores de servicios marítimos. Contáctenos a través de nuestra página de Contacto.',
        // New Keys
        'Proof Vessels': '150+',
        'Proof Vessels Text': 'Buques Activos y Gestionados',
        'Proof Countries': '50+',
        'Proof Countries Text': 'Países Servidos en Aguas Globales',
        'Proof Support': '24/7',
        'Proof Support Text': 'Soporte de Operaciones Marítimas y Offshore',
        'Footer Subscribe Heading': 'Suscríbase a nuestro boletín',
        'Footer Subscribe Btn': 'Suscribirse',
        'Footer Business Heading': 'Haciendo Negocios Juntos',
        'Footer Link What': 'Qué hacemos',
        'Footer Link Fleets': 'Mercado',
        'Footer Link Offshore': 'Servicios offshore',
        'Footer Link Security': 'Seguridad marina',
        'Footer Link Charter': 'Fletamento y gestión de buques',
        'Footer Link Partnership': 'Asociaciones',
        // Admin Login
        'Admin Login': 'Inicio de Sesión de Administrador',
        'Secure Access': 'Ingrese sus credenciales para acceder al panel',
        'Email Address': 'Dirección de Correo Electrónico',
        'Password': 'Contraseña',
        'Login': 'Iniciar Sesión',
        'Footer Know Heading': 'Conózcanos',
        'Footer Link About': 'Acerca de Romeo Alpha',
        'Footer Link News': 'Noticias e Ideas',
        'Footer Link Careers': 'Carreras',
        'Footer Link Contact': 'Contáctenos',
        'Footer Address': 'Sede - +2348066184330 / +2348055769660 - info@romeoalphamaritime.com / Kyoyan99@yahoo.com - No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'CAC Registration': 'RC: 9257242 - Registrado ante la Comisión de Asuntos Corporativos (CAC)',
        'Scroll Top': 'Inicio',
        'Unread': 'No leídos',
        // About Page
        'About Hero Title': 'Acerca de Romeo Alpha',
        'About Hero Subtitle': 'Liderando el camino en soluciones marítimas globales y excelencia offshore.',
        'Mission Title': 'Nuestra Misión',
        'Mission Text': 'Proporcionar servicios de transporte marítimo y apoyo offshore seguros, confiables y eficientes que superen las expectativas del cliente.',
        'Vision Title': 'Nuestra Visión',
        'Vision Text': 'Ser el socio global preferido en la industria marítima, reconocido por nuestro compromiso con la excelencia.',
        'Who We Are Title': 'Quiénes Somos',
        'Who We Are Desc': 'Romeo Alpha Maritime Consultants & Logistics International Ltd es un proveedor líder de transporte marino y servicios de apoyo offshore.',
        'Who We Are Desc 2': 'Fundada sobre los principios de integridad y seguridad, nos hemos convertido en un nombre de confianza en la industria.',
        'Stat Years': '10+',
        'Stat Years Label': 'Años de Experiencia',
        'Stat Vessels': '150+',
        'Stat Vessels Label': 'Buques Gestionados',
        'Stat Partners': '50+',
        'Stat Partners Label': 'Socios Globales',
        'Get in touch': 'Ponerse en contacto',
        // Fleets Page
        'Fleets Hero Title': 'Nuestra Flota Global',
        'Fleets Hero Subtitle': 'Una flota versátil y moderna diseñada para la seguridad, la eficiencia y el alcance global.',
        'Fleet Overview Title': 'Descripción General de la Flota',
        'Fleet Overview Desc': 'Romeo Alpha gestiona una cartera diversa de buques, desde transportistas de carga a gran escala hasta unidades de apoyo offshore especializadas.',
        'Total Vessels': 'Total de Buques',
        'Vessel Types': 'Tipos de Buques',
        'Avg Age': 'Edad Promedio',
        'Cat Offshore': 'Buques de Apoyo Offshore',
        'Cat Cargo': 'Flota de Carga y Tanqueros',
        'View Spec': 'Ver Especificaciones',
        // Team Page
        'Team Hero Title': 'Conozca a nuestros líderes',
        'Team Hero Subtitle': 'Los profesionales experimentados que impulsan la excelencia marítima.',
        'Team Intro': 'En Romeo Alpha, nuestro éxito se basa en la experiencia, dedicación y liderazgo de nuestra gente.',
        'Founder Label': 'FUNDADOR Y VISIONARIO',
        'MD Label': 'DIRECTOR GENERAL',
        'Core Team Title': 'Equipo de Liderazgo Principal',
        'Join Team Title': '¿Quieres unirte a nuestra tripulación?',
        'Join Team Subtitle': 'Siempre estamos buscando personas talentosas para unirse a nuestra familia en crecimiento.',
        'See Openings': 'Ver vacantes',
        // Additional Keys
        'Ans Header': 'Resp.',
        'FAQ Header': 'Preguntas.',
        'Search Placeholder': 'Buscar un servicio...',
        'Category All': 'Todos los Servicios',
        'Category Offshore': 'En Venta',
        'Category Logistics': 'Para Alquiler',
        'Category Charter': 'Reparación',
        'Category Port': 'Chatarra',
        'Marketplace Sale': 'En Venta',
        'Marketplace Hire': 'Para Alquiler',
        'Marketplace Repair': 'Reparación',
        'Marketplace Scrap': 'Chatarra',
        'No Results': 'No se encontraron resultados.',
        'Operations Page Title': 'Mercado Marino',
        'Operations Page Subtitle': 'Explore buques en venta, alquiler, reparaciones y chatarra.',
        'Contact Hero Title': 'Póngase en Contacto',
        'Contact Hero Subtitle': 'Estamos aquí para ayudarle con sus necesidades marítimas y offshore.',
        'Visit Office Heading': 'Visite Nuestra Oficina',
        'Lets Talk Heading': 'Hablemos',
        'Call Us CTA': 'Llámenos',
        'Inbox Heading': 'Bandeja de Entrada',
        'Email Us CTA': 'Enviar Correo',
        'Support Text': 'Póngase en contacto y háganos saber cómo podemos ayudarle.',
        'About Btn': 'Acerca de la Empresa',
        'Form Title': 'Envíenos un mensaje',
        'Form Name': 'Nombre Completo',
        'Form Email': 'Correo Electrónico',
        'Form Subject': 'Asunto',
        'Form Message': 'Mensaje',
        'Form Submit': 'Enviar Mensaje',
        'Careers Hero Title': 'Únete a nuestro equipo',
        'Careers Hero Subtitle': 'Construye tu futuro con un líder global en excelencia marítima.',
        'Careers Label': 'CARRERAS',
        'Working Title': 'Trabajando en Romeo Alpha',
        'Working P1': 'Nuestra gente es la base de nuestro éxito. Proporcionamos un entorno de apoyo donde los profesionales pueden crecer.',
        'Working P2': 'Nos enorgullecemos de nuestro compromiso con la seguridad, el profesionalismo y el bienestar de nuestro personal.',
        'Get In Touch': 'Ponerse en Contacto',
        'Recruitment Title': 'Reclutamiento',
        'Recruitment P1': 'Nuestro proceso de reclutamiento está estructurado para identificar el mejor talento de la industria.',
        'Recruitment P2': 'Estamos constantemente buscando personas que compartan nuestra visión de excelencia e innovación.',
        'Related Subtitle': 'explorar otros servicios',
        // Common UI & SEO
        'Logo Alt': 'Logotipo de la Empresa',
        'Email Placeholder': 'Correo electrónico',
        'Copyright': '© 2026 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        // SEO Metadata
        'SEO Home Title': 'Envío de Buques, Apoyo Offshore y Escolta Marina',
        'SEO Home Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd ofrece fletamento de buques, apoyo offshore, escolta de seguridad marina, reparación de buques y venta de chatarra.',
        'SEO Home Keywords': 'marítimo, envío, apoyo offshore, buque escolta de seguridad, fletamento de buques, gestión de buques',
        'SEO About Title': 'Sobre Nosotros - Especialistas en Logística Marítima Global',
        'SEO About Desc': 'Conozca Romeo Alpha Maritime, nuestra misión, visión, capacidad de flota y compromiso con el transporte marítimo global y el apoyo a plataformas petroleras.',
        'SEO About Keywords': 'acerca de romeo alpha, tripulación marina, consultores marinos, cumplimiento marítimo',
        'SEO Marketplace Title': 'Mercado Marino - Buques en Venta, Alquiler y Chatarra',
        'SEO Marketplace Desc': 'Explore nuestro mercado marino. Compre o alquile buques de apoyo offshore, remolcadores, reparación de buques y venta de chatarra.',
        'SEO Marketplace Keywords': 'comprar buque, alquilar remolcador, chatarra marina, reparación de buques, servicio de plataformas',
        'SEO Team Title': 'Nuestro Equipo de Liderazgo - Capitanes Experimentados',
        'SEO Team Desc': 'Conozca a nuestro equipo directivo, incluidos el Capitán Smart-Alli y el Capitán James Sterling, con décadas de experiencia en navegación.',
        'SEO Team Keywords': 'capitán smart-alli, capitanes de buques, líderes marítimos, gestión de envíos',
        'SEO Careers Title': 'Carreras - Únase a Nuestro Equipo Marítimo y Offshore',
        'SEO Careers Desc': 'Construya su futuro en Romeo Alpha. Ofrecemos oportunidades profesionales para tripulación cualificada, técnicos offshore e ingenieros marinos.',
        'SEO Careers Keywords': 'empleos marítimos, tripulación, ingenieros marinos, trabajos en barcos',
        'SEO Contact Title': 'Contáctenos - Centro de Operaciones Marítimas 24/7',
        'SEO Contact Desc': 'Póngase en contacto con Romeo Alpha Maritime. Solicite un presupuesto para envíos, fletamento de buques, seguridad marina o mantenimiento de plataformas.',
        'SEO Contact Keywords': 'contacto romeo alpha, solicitar presupuesto, soporte marino, consultas de armadores',
        'SEO Service Maritime Title': 'Servicios de Transporte Marítimo y Envío',
        'SEO Service Maritime Desc': 'Servicios de transporte marítimo seguros y confiables en aguas internacionales y de África Occidental. Gestión de logística de carga.',
        'SEO Service Maritime Keywords': 'transporte de carga, tránsito marítimo, transporte de buques, envío áfrica occidental',
        'SEO Service Charter Title': 'Fletamento de Buques y Gestión de barcos',
        'SEO Service Charter Desc': 'Servicios a medida de fletamento y gestión de buques. Suministro de tripulación cualificada, abastecimiento de combustible e inspecciones.',
        'SEO Service Charter Keywords': 'fletamento de buques, gestión de buques, abastecimiento de combustible, inspección de buques',
        'SEO Service Offshore Title': 'Apoyo a Operaciones Offshore y Campos Petroleros',
        'SEO Service Offshore Desc': 'Soporte confiable para plataformas offshore, mantenimiento de plataformas petroleras, logística de campos petroleros y remolque.',
        'SEO Service Offshore Keywords': 'apoyo offshore, servicio de plataformas, logística petrolera, remolcador de manejo de anclas',
        'SEO Service Security Title': 'Escolta de Seguridad Marina y Protección de Activos',
        'SEO Service Security Desc': 'Seguridad marítima integral, buques de escolta armados y evaluaciones de riesgos para el tránsito en zonas de alto riesgo.',
        'SEO Service Security Keywords': 'seguridad marina, buque de escolta armado, protección marítima, evaluación de riesgos',
        // Service Details
        'Key Operations': 'Operaciones Clave',
        'Other Services': 'Otros Servicios',
        'Charter Operations': 'Operaciones de Fletamento',
        'Offshore Operations': 'Operaciones de Apoyo Offshore',
        'Security Operations': 'Operaciones de Seguridad',
        'Armed Guards': 'Guardias Armados',
        'Risk Assessment': 'Evaluación de Riesgos',
        // Partnership Form
        'Partnership Heading': 'Construya con Romeo Alpha',
        'Partnership Subheading': 'Amplíe su alcance marítimo a través de una alianza estratégica.',
        'Label Company': 'Nombre de la Empresa',
        'Label Representative': 'Representante de Contacto',
        'Label Email': 'Correo de Negocios',
        'Label Phone': 'Número de Teléfono',
        'Label Interest': 'Área de Interés de Servicio',
        'Label Message': 'Propuesta / Mensaje',
        'Placeholder Company': 'Ingrese el nombre de su empresa',
        'Placeholder Representative': 'Nombre completo',
        'Placeholder Email': 'email@empresa.com',
        'Placeholder Phone': '+234...',
        'Partnership Placeholder Message': 'Describa su visión de asociación...',
        'Option Shipping': 'Transporte y Logística',
        'Option Technical': 'Servicios Técnicos Marinos',
        'Option Security': 'Seguridad Marítima',
        'Option Marketplace': 'Mercado de Buques',
        'Option Other': 'Otra Alianza Potencial',
        'Partnership Success': '¡Gracias! Nuestro equipo de asociaciones lo contactará pronto.',
        'Partnership Btn': 'Enviar Propuesta de Asociación',
        'Sending': 'Enviando...',
        // Contact Form
        'Form Success Alert': '¡Gracias! Su mensaje ha sido enviado y guardado.',
        'Placeholder Name': 'Juan Pérez',
        'Placeholder Subject': 'ej. Consulta sobre buque',
        'Placeholder Message': 'Su mensaje aquí...',
        // Marketplace
        'Interested CTA': 'Interesado en contactar',
        'Tag Available': 'Disponible',
        'Tag Marketplace': 'Mercado',
        'Tag Featured': 'Destacado',
        // Operation Detail
        'Expertise Heading': 'Nuestra Experiencia',
        'Expertise 1': 'Alcance operativo global',
        'Expertise 2': 'Navegación segura y confiable',
        'Expertise 3': 'Flota de buques mantenida expertamente',
        'Expertise 4': 'Profesionales marítimos altamente capacitados',
        'Inquiry Heading': 'Consultar Sobre Este Servicio',
        'Inquiry Placeholder Message': '¿Cómo podemos ayudarle con esta operación?',
        'Inquiry Submit': 'Enviar Consulta',
        'Images Left': 'imágenes restantes',
        // Team Bios
        'CEO Name': 'Captain Smart-Alli',
        'CEO Title': 'Director Ejecutivo',
        'CEO Quote': '"Nuestro viaje se define por la confianza que generamos en el mar y la excelencia que entregamos en cada milla náutica."',
        'CEO Bio 1': 'Más de tres décadas de experiencia y pericia en transporte marítimo e industria de petróleo y gas.',
        'CEO Bio 2': '',
        'James Name': 'Cap. James Sterling',
        'James Bio 1': 'El Cap. James Sterling aporta una riqueza de experiencia incomparable...',
        'James Bio 2': 'Su liderazgo asegura que cada misión se ejecute con el más alto grado de profesionalismo.',
        'Sarah Name': 'Sarah Okafor',
        'Sarah Bio': 'Experta en coordinación logística offshore y optimización de la cadena de suministro.',
        'David Name': 'Ing. David Chen',
        'David Bio': 'Ingeniero Jefe especializado en mantenimiento de buques y cumplimiento técnico.',
        'Elena Name': 'Elena Rodriguez',
        'Elena Bio': 'Dedicada a mantener estándares de seguridad de clase mundial.',
        'Marcus Name': 'Marcus Thorne',
        'Marcus Bio': 'Especialista en despliegue de buques y gestión de tripulación.',
        // Marketplace Detail & Listing
        'Marketplace Loading': 'Cargando detalles del artículo...',
        'Item Not Found': 'Artículo No Encontrado',
        'Item Error Desc': 'El artículo del mercado que busca no existe o ha sido eliminado.',
        'Back to Marketplace': 'Volver al Mercado',
        'Item Description': 'Descripción del Artículo',
        'Key Specifications': 'Especificaciones Clave',
        'Label Category': 'Categoría:',
        'Label Location': 'Ubicación:',
        'Label Area': 'Zona:',
        'Label Badges': 'Etiquetas:',
        'Immediate': 'Inmediato',
        'Default Area': 'Port Harcourt, Nigeria',
        'Send Inquiry Detail': 'Enviar Consulta',
        'Maritime Consultant': 'Consultor Marítimo',
        'Consultant Ready': 'Listo para ayudar con su adquisición.',
        'Back': 'Atrás',
        'Marketplace Featured': 'Destacado',
        'Marketplace Available': 'Disponible',
        'Enquire': 'Consultar',
        'Reach out': 'Contacto',
        'Price': 'Precio',
        'Service Help Text': '¿Quiere dar servicio a plataformas o construir casas bote?',
        'See Details': 'Ver Detalles',
        // Admin Dashboard
        'Admin Email Placeholder': 'admin@romeoalpha.com',
        'Access Denied': 'Acceso Denegado: No tiene privilegios de administrador.',
        'Verifying': 'Verificando...',
        'General Error': 'Algo salió mal. Por favor, inténtelo de nuevo.',
        'Dashboard Overview': 'Visión General del Panel',
        'Recent Activity': 'Actividad Reciente',
        'Active Listings': 'Listados Activos',
        'Vessels for Sale': 'Buques en Venta',
        'Marine Marketplace': 'Mercado Marino',
        'Manage Vessels': 'Gestionar buques para venta, alquiler, reparación y chatarra.',
        'Add New Item': 'Agregar Nuevo Artículo',
        'Edit Marketplace Item': 'Editar Artículo del Mercado',
        'Save Item': 'Guardar Artículo',
        'Update Item': 'Actualizar Artículo',
        'Cancel': 'Cancelar',
        'Title': 'Título',
        'Category': 'Categoría',
        'Price Placeholder': 'ej. ₦1,200,000 o Contactar para Precio',
        'Vessel Status': 'Estado',
        'Vessel Area': 'Zona',
        'Description': 'Descripción',
        'Badges Placeholder': 'ej. Soporte, Offshore, Rig Move',
        'Upload Images': 'Subir Imágenes (Máx 5)',
        'Item Added Success': '¡Artículo agregado con éxito!',
        'Item Updated Success': '¡Artículo actualizado con éxito!',
        'Delete Confirm': '¿Está seguro de que desea eliminar este artículo?',
        'Newsletter Hub': 'Centro de Boletín',
        'Subscriber List': 'Ver y gestionar su lista de suscriptores',
        'Refresh List': 'Actualizar Lista',
        'Subscriber Email': 'Correo del Suscriptor',
        'Joined Date': 'Fecha de Unión',
        'Actions': 'Acciones',
        'Remove Subscriber': '¿Eliminar suscriptor de la lista?',
        'FAQ Management': 'Gestión de FAQ',
        'Add New FAQ': 'Agregar Nueva FAQ',
        'Question': 'Pregunta',
        'Answer': 'Respuesta',
        'Save FAQ': 'Guardar FAQ',
        'Update FAQ': 'Actualizar FAQ',
        'FAQ Delete Confirm': '¿Está seguro de que desea eliminar esta FAQ?',
        'Dashboard': 'Panel',
        'Newsletter': 'Boletín',
        'Logout': 'Cerrar Sesión',
        'Admin User': 'Usuario Admin',
        'Administrator': 'Administrador',
        'Headquarters': 'Sede Principal',
        'Messages': 'Mensajes',
        'Manage Messages': 'Ver y gestionar mensajes entrantes',
        'No Messages': 'No se encontraron mensajes.',
        'View Message': 'Ver Mensaje',
        'Mark as Read': 'Marcar como leído',
        'Mark as Unread': 'Marcar como no leído',
        'No Subject': 'Sin Asunto',
        'Received Date': 'Fecha de Recepción',
        // Upload / Ads Management
        'Upload': 'Anuncios',
        'Upload Image': 'Subir Nuevo Anuncio',
        'Upload New Ad Image': 'Subir Banner Publicitario',
        'Select Image': 'Seleccionar Archivo de Imagen',
        'Uploading': 'Subiendo...',
        'Save Ad': 'Guardar Anuncio',
        'Ad Added Success': '¡Anuncio agregado con éxito!',
        'No Ads found': 'No se encontraron anuncios.',
        'Loading Ads': 'Cargando Anuncios...',
        // Marketplace Inquiry
        'Submit Inquiry Title': 'Enviar Consulta',
        'Full Name': 'Nombre Completo',
        'Inquiry Message': 'Mensaje de Consulta',
        'Discussion Details': 'Detalles de la Discusión',
        'Contact Person': 'Persona de Contacto',
        'Sending Request': 'Enviando Solicitud...',
        'Inquiry Success': '¡Consulta enviada con éxito!',
        'Inquiry Error': 'Fallo al enviar la consulta. Inténtelo de nuevo.',
        'Close': 'Cerrar',
        // Header/Footer & Misc
        'Language': 'Idioma',
        'Switch Language': 'Cambiar Idioma',
        'Explore Our Services': 'Explore Nuestros Servicios',
        'Back to Home': 'Volver al Inicio',
        'Role Head of Operations': 'Jefe de Operaciones',
        'Role Technical Director': 'Director Técnico',
        'Label Portharcourt': 'No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'General Message Error': 'Error al enviar el mensaje. Inténtelo de nuevo más tarde.',
        'Team Info Heading': 'Nuestro Liderazgo',
        'Meet the Team': 'Conocer al Equipo',
        'Lang English': 'English',
        'Lang Spanish': 'Español',
        'Lang French': 'Français',
        'Lang German': 'Deutsch',
        'Lang Chinese': '中文 (Chinese)',
        'Delete': 'Eliminar',
        'Error Label': 'Error',
        'Try Refresh': 'Refrescar',
        'Files Selected': 'archivos seleccionados',
        'NA': 'N/D',
        'Mass Delete Confirm': '¿Está seguro de que desea eliminar estos elementos?',
        'Delete Success': 'Elementos eliminados con éxito',
        'Form Required Error': 'El título y la descripción son obligatorios',
        'FAQ Required Error': 'La pregunta y la respuesta son obligatorias',
        'Marketplace Empty State': 'Los artículos del mercado aparecerán aquí una vez que comience a agregarlos.',
        'FAQ Empty State': 'No se encontraron preguntas frecuentes. Agrega una para comenzar.',
        'Newsletter Empty State': 'No se encontraron suscriptores.',
        'File Size Error': 'El archivo es demasiado grande',
    },
    'fr': {
        'Notice Welcome': 'Bienvenue chez Romeo Alpha Maritime Consultants and Logistics International Ltd',
        'Home': 'Accueil',
        'About us': 'À propos de nous',
        'Operations': 'Opérations',
        'Our fleets': 'Marché',
        'Marketplace': 'Marché',
        'Our team': 'Notre équipe',
        'Careers': 'Carrières',
        'Contact us': 'Contactez-nous',
        'Get Quotes': 'Obtenir un devis',
        'Hero Heading': 'Propulser le transport maritime et les opérations offshore',
        'Hero Subheading': 'Fournir des services d\'expédition sûrs et fiables, une escorte de sécurité maritime et un soutien pétrolier et gazier offshore dans les eaux côtières et internationales',
        'Browse Operations': 'Parcourir nos opérations',
        // Quick Links
        'Quick Marine Title': 'Équipement et navires marins',
        'Quick Marine Desc': 'Parcourez notre vaste inventaire d\'équipements marins et de navires à vendre. Des remorqueurs aux navires de soutien offshore.',
        'Quick Marine Btn': 'Acheter maintenant',
        'Quick Repair Title': 'Réparations et ventes de ferraille',
        'Quick Repair Desc': 'Services professionnels de réparation de navires et vente de ferraille. Nous gérons tout, de la réparation mineure au recyclage.',
        'Quick Repair Btn': 'Réparer maintenant',
        'Quick Construction Title': 'Construction de Structures Marines',
        'Quick Construction Desc': 'Construction experte d\'infrastructures marines incluant docks, jetées et plateformes offshore.',
        'Quick Construction Btn': 'Construire maintenant',
        'Quick Servicing Title': 'Entretien de Plateformes Pétrolières',
        'Quick Servicing Desc': 'Entretien complet et maintenance pour plateformes pétrolières et plateformes offshore.',
        'Quick Servicing Btn': 'Entretenir maintenant',
        'Content Heading': 'Nos Solutions de Transport et Logistique pour chaque besoin',
        'Content Subtext': 'Nous fournissons des services intégrés de transport maritime et de soutien offshore.',
        'Banner Heading': 'Faisons des affaires ensemble',
        'Banner Subtext': 'Associez-vous à nous pour toutes vos solutions de transport, opérations et sécurité maritime dans le monde entier.',
        'Banner Button': 'Associez-vous à nous dès aujourd\'hui',
        // Benefit Section
        'Why Romeo Alpha': 'Pourquoi Romeo Alpha ?',
        'Why Subtext': 'Nous livrons des solutions maritimes et offshore fiables basées sur l\'expérience et la sécurité.',
        'Benefit 1 Title': 'Expertise Maritime Éprouvée',
        'Benefit 1 Desc': 'Nos opérations sont dirigées par des professionnels maritimes chevronnés ayant une connaissance approfondie du transport.',
        'Benefit 2 Title': 'Opérations Fiables et Sûres',
        'Benefit 2 Desc': 'La sécurité et la fiabilité sont au cœur de tout ce que nous faisons. Nous respectons les normes internationales.',
        'Benefit 3 Title': 'Support Offshore de Bout en Bout',
        'Benefit 3 Desc': 'De l\'affrètement de navires au soutien aux plateformes offshore, nous offrons des solutions intégrées.',
        'Benefit 4 Title': 'Portée Mondiale, Vision Locale',
        'Benefit 4 Desc': 'Nous soutenons les opérations dans les eaux côtières et internationales, combinant portée mondiale et expertise régionale.',
        'Benefit 5 Title': 'Solutions Flexibles et Evolutives',
        'Benefit 5 Desc': 'Nos services sont adaptés à vos besoins opérationnels, que ce soit pour des missions à court ou long terme.',
        'Benefit 6 Title': 'Approche Orientée Partenariat',
        'Benefit 6 Desc': 'Nous travaillons en étroite collaboration avec nos clients pour construire des partenariats à long terme.',
        // Service Section
        'Services Heading': 'Nos Services',
        'Services Subheading': 'Nous livrons des solutions maritimes, offshore et logistiques complètes adaptées aux besoins des exploitants de navires.',
        'Service 1 Title': 'Gestion de Navires',
        'Service 1 Desc': 'Notre objectif est de fournir des services compétents, sûrs et rentables basés sur les besoins des clients.',
        'Service 2 Title': 'Inspection et Expertise de Navires',
        'Service 2 Desc': 'Nous prenons le temps de comprendre les besoins de nos clients et mettons les bonnes personnes sur le terrain.',
        'Service 3 Title': 'Services de Courtage',
        'Service 3 Desc': 'Notre branche de courtage maritime a fait ses preuves en fournissant un niveau de service inégalé.',
        'Service 4 Title': 'Affrètement',
        'Service 4 Desc': 'Notre équipe d\'affrètement de navires peut trouver le navire précis, à l\'emplacement exact et au bon moment.',
        'Service 5 Title': 'Vente de Navires pour Ferraille',
        'Service 5 Desc': 'Notre connaissance approfondie du marché de la ferraille fait de nous le représentant de vente idéal.',
        'Service 6 Title': 'Équipage',
        'Service 6 Desc': 'Nous fournissons un équipage dûment qualifié pour les navires conformément aux normes actuelles.',
        'Service 7 Title': 'Soutage',
        'Service 7 Desc': 'Notre société a la capacité requise pour offrir le soutage de carburant marin dans les principaux ports.',
        'Service 8 Title': 'Gestion de Projet et Opérations',
        'Service 8 Desc': 'Nous veillons à ce que les projets soient gérés selon une approche structurée avec les ressources appropriées.',
        'Service 9 Title': 'Sécurité Maritime',
        'Service 9 Desc': 'Romeo Alpha propose des solutions complètes de sécurité maritime, incluant l\'escorte et les gardes armés.',
        'Service 10 Title': 'Marine Générale',
        'Service 10 Desc': 'Nos services de marine générale visent à fournir des solutions maritimes sûres, efficaces et fiables.',
        'Overlay Maritime': 'Transport Maritime<br>et Opération',
        'Overlay Charter': 'Affrètement et Gestion<br>de Navires',
        'Overlay Offshore': 'Soutien Offshore et<br>Champs Pétroliers',
        'Overlay Security': 'Escorte de<br>Sécurité Maritime',
        'Overlay Repair': 'Réparation de Navires<br>et Vente de Ferraille',
        'Explore Service': 'Explorer le service',
        // Ads Section
        'Ads Heading': 'Romeo Alpha vous accompagne',
        'Ads Subtext': 'Besoin d\'une expédition fiable ? Romeo Alpha propose des solutions maritimes de confiance.',
        'Tag Marine': 'Transport Maritime',
        'Tag Offshore': 'Soutien Offshore',
        'Tag Charter': 'Affrètement de Navires',
        'Tag Security': 'Escorte de Sécurité Maritime',
        'Tag Logistics': 'Logistique Pétrole et Gaz',
        'Tag Global': 'Opérations Mondiales',
        'FAQ Title': 'Questions Fréquentes',
        // FAQ Section
        'FAQ_Q1': 'Quels services maritimes Romeo Alpha propose-t-il ?',
        'FAQ_A1': 'Romeo Alpha propose des services maritimes complets comprenant l\'affrètement de navires, le soutien offshore, l\'escorte de sécurité maritime, le courtage, la logistique de fret, ainsi que des opérations pétrolières et gazières internationales.',
        'FAQ_Q2': 'Dans quelles zones opérez-vous ?',
        'FAQ_A2': 'Nous opérons mondialement sur les principales routes maritimes. Notre couverture principale comprend les eaux d\'Afrique de l\'Ouest, le golfe de Guinée, la Méditerranée et les couloirs internationaux reliant l\'Afrique, l\'Europe et les Amériques.',
        'FAQ_Q3': 'Comment puis-je demander un devis ?',
        'FAQ_A3': 'Vous pouvez demander un devis en cliquant sur "Obtenir un devis", par e-mail ou en appelant notre centre d\'opérations 24h/24. Notre équipe répond généralement sous 24 heures avec une proposition détaillée.',
        'FAQ_Q4': 'Quels types de navires composent votre flotte ?',
        'FAQ_A4': 'Notre flotte comprend des navires de soutien offshore (OSV), des remorqueurs (AHTS), des navires de ravitaillement (PSV), des bateaux de transport d\'équipage et des navires d\'escorte de sécurité. Tous sont conformes aux normes internationales.',
        'FAQ_Q5': 'Assurez-vous un support opérationnel 24h/24 et 7j/7 ?',
        'FAQ_A5': 'Oui, nous maintenons des opérations 24h/24 avec une équipe de support dédiée. Notre centre d\'opérations surveille tous les navires actifs et peut répondre aux urgences à tout moment.',
        'FAQ_Q6': 'Quelles certifications de sécurité possédez-vous ?',
        'FAQ_A6': 'Romeo Alpha détient la certification du Code ISM, ISO 9001:2015 pour la gestion de la qualité, et respecte les exigences SOLAS, MARPOL et du Code ISPS.',
        'FAQ_Q7': 'Comment puis-je devenir partenaire de Romeo Alpha ?',
        'FAQ_A7': 'Nous accueillons les partenariats avec les compagnies maritimes, les opérateurs pétroliers et gaziers. Contactez notre équipe de développement commercial via notre page Contact.',
        // New Keys
        'Proof Vessels': '150+',
        'Proof Vessels Text': 'Navires Actifs et Gérés',
        'Proof Countries': '50+',
        'Proof Countries Text': 'Pays Servis dans les Eaux Mondiales',
        'Proof Support': '24/7',
        'Proof Support Text': 'Support Opérationnel Maritime et Offshore',
        'Footer Subscribe Heading': 'Abonnez-vous à notre newsletter',
        'Footer Subscribe Btn': 'S\'abonner',
        'Footer Business Heading': 'Faire des Affaires Ensemble',
        'Footer Link What': 'Ce que nous faisons',
        'Footer Link Fleets': 'Marché',
        'Footer Link Offshore': 'Services offshore',
        'Footer Link Security': 'Sécurité maritime',
        'Footer Link Charter': 'Affrètement et gestion de navires',
        'Footer Link Partnership': 'Partenariats',
        // Admin Login
        'Admin Login': 'Connexion Administrateur',
        'Secure Access': 'Entrez vos identifiants pour accéder au tableau de bord',
        'Email Address': 'Adresse E-mail',
        'Password': 'Mot de passe',
        'Login': 'Connexion',
        'Footer Know Heading': 'Faites Connaissance avec Nous',
        'Footer Link About': 'À propos de Romeo Alpha',
        'Footer Link News': 'Nouvelles et Perspectives',
        'Footer Link Careers': 'Carrières',
        'Footer Link Contact': 'Contactez-nous',
        'Footer Address': 'Siège - +2348066184330 / +2348055769660 - info@romeoalphamaritime.com / Kyoyan99@yahoo.com - No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'CAC Registration': 'RC: 9257242 - Registré auprès de la Commission des Affaires Corporatives (CAC)',
        'Scroll Top': 'Haut',
        'Unread': 'Non lus',
        // About Page
        'About Hero Title': 'À propos de Romeo Alpha',
        'About Hero Subtitle': 'Ouvrir la voie dans les solutions maritimes mondiales.',
        'Mission Title': 'Notre Mission',
        'Mission Text': 'Fournir des services de transport maritime et de soutien offshore sûrs, fiables et efficaces.',
        'Vision Title': 'Notre Vision',
        'Vision Text': 'Être le partenaire mondial privilégié du secteur maritime.',
        'Who We Are Title': 'Qui Nous Sommes',
        'Who We Are Desc': 'Romeo Alpha Maritime Consultants & Logistics International Ltd est un fournisseur de premier plan de transport maritime.',
        'Who We Are Desc 2': 'Fondé sur les principes d\'intégrité et de sécurité, nous sommes un nom de confiance dans l\'industrie.',
        'Stat Years': '10+',
        'Stat Years Label': 'Années d\'Expérience',
        'Stat Vessels': '150+',
        'Stat Vessels Label': 'Navires Gérés',
        'Stat Partners': '50+',
        'Stat Partners Label': 'Partenaires Mondiaux',
        'Get in touch': 'Entrer en contact',
        // Fleets Page
        'Fleets Hero Title': 'Notre Flotte Mondiale',
        'Fleets Hero Subtitle': 'Une flotte polyvalente et moderne conçue pour la sécurité.',
        'Fleet Overview Title': 'Aperçu de la Flotte',
        'Fleet Overview Desc': 'Romeo Alpha gère un portefeuille diversifié de navires.',
        'Total Vessels': 'Total des Navires',
        'Vessel Types': 'Types de Navires',
        'Avg Age': 'Âge Moyen',
        'Cat Offshore': 'Navires de Soutien Offshore',
        'Cat Cargo': 'Flotte de Cargos et de Pétroliers',
        'View Spec': 'Voir les Spécifications',
        // Team Page
        'Team Hero Title': 'Rencontrez nos dirigeants',
        'Team Hero Subtitle': 'Des professionnels expérimentés au service de l\'excellence maritime.',
        'Team Intro': 'Chez Romeo Alpha, notre succès repose sur l\'expertise et le dévouement de nos employés.',
        'Founder Label': 'FONDATEUR ET VISIONNAIRE',
        'MD Label': 'DIRECTEUR GÉNÉRAL',
        'Core Team Title': 'Équipe de Direction Principale',
        'Join Team Title': 'Vous voulez rejoindre notre équipage ?',
        'Join Team Subtitle': 'Nous recherchons toujours des personnes talentueuses.',
        'See Openings': 'Voir les postes',
        // Additional Keys
        'Ans Header': 'Rép.',
        'FAQ Header': 'FAQs.',
        'Search Placeholder': 'Rechercher un service...',
        'Category All': 'Tous les Services',
        'Category Offshore': 'À Vendre',
        'Category Logistics': 'À Louer',
        'Category Charter': 'Réparation',
        'Category Port': 'Ferraille',
        'Marketplace Sale': 'À Vendre',
        'Marketplace Hire': 'À Louer',
        'Marketplace Repair': 'Réparation',
        'Marketplace Scrap': 'Ferraille',
        'No Results': 'Aucun résultat trouvé.',
        'Operations Page Title': 'Marché Marin',
        'Operations Page Subtitle': 'Explorez les navires à vendre, à louer, réparations et ferrailles.',
        'Contact Hero Title': 'Contactez-nous',
        'Contact Hero Subtitle': 'Nous sommes là pour vous aider à répondre à vos besoins.',
        'Visit Office Heading': 'Visitez Notre Bureau',
        'Lets Talk Heading': 'Discutons',
        'Call Us CTA': 'Appelez-nous',
        'Inbox Heading': 'Boîte de Réception',
        'Email Us CTA': 'Envoyer un E-mail',
        'Support Text': 'Contactez-nous et dites-nous comment nous pouvons vous aider.',
        'About Btn': 'À propos de l\'Entreprise',
        'Form Title': 'Envoyez-nous un message',
        'Form Name': 'Nom Complet',
        'Form Email': 'Adresse E-mail',
        'Form Subject': 'Sujet',
        'Form Message': 'Message',
        'Form Submit': 'Envoyer le Message',
        'Careers Hero Title': 'Rejoignez notre équipe',
        'Careers Hero Subtitle': 'Bâtissez votre avenir avec un leader mondial.',
        'Careers Label': 'CARRIÈRES',
        'Working Title': 'Travailler chez Romeo Alpha',
        'Working P1': 'Nos collaborateurs sont le fondement de notre succès.',
        'Working P2': 'Nous sommes fiers de notre engagement envers la sécurité et le professionnalisme.',
        'Get In Touch': 'Entrer en Contact',
        'Recruitment Title': 'Recrutement',
        'Recruitment P1': 'Notre processus de recrutement est structuré pour identifier les meilleurs talents.',
        'Recruitment P2': 'Nous sommes constamment à la recherche de personnes partageant notre vision.',
        'Related Subtitle': 'explorer d\'autres services',
        // Common UI & SEO
        'Logo Alt': 'Logo de l\'Entreprise',
        'Email Placeholder': 'E-mail',
        'Copyright': '© 2026 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        // SEO Metadata
        'SEO Home Title': 'Expédition de Navires, Support Offshore & Escorte Maritime',
        'SEO Home Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd fournit des services d\'affrètement de navires, de soutien offshore, d\'escorte de sécurité maritime, de réparation de navires et de vente de ferraille.',
        'SEO Home Keywords': 'maritime, expédition, support offshore, navire d\'escorte, affrètement de navire, gestion de flotte',
        'SEO About Title': 'À Propos de Nous - Spécialistes de la Logistique Maritime Globale',
        'SEO About Desc': 'Découvrez Romeo Alpha Maritime, notre mission, notre vision, notre flotte et notre engagement envers le transport maritime international.',
        'SEO About Keywords': 'à propos de romeo alpha, équipage maritime, consultants maritimes, conformité solas',
        'SEO Marketplace Title': 'Marché Maritime - Navires à Vendre, à Louer & Ferraille',
        'SEO Marketplace Desc': 'Explorez notre marché maritime. Achetez ou louez des navires de soutien offshore, des remorqueurs, des réparations navales et de la ferraille.',
        'SEO Marketplace Keywords': 'acheter navire, louer remorqueur, ferraille maritime, réparation navale',
        'SEO Team Title': 'Notre Équipe de Direction - Capitaines de Marine Expérimentés',
        'SEO Team Desc': 'Rencontrez nos dirigeants, notamment le capitaine Smart-Alli et le capitaine James Sterling, apportant des décennies de gestion de navigation.',
        'SEO Team Keywords': 'capitaine smart-alli, capitaines au long cours, dirigeants maritimes',
        'SEO Careers Title': 'Carrières - Rejoignez Notre Équipe Maritime et Offshore',
        'SEO Careers Desc': 'Construisez votre avenir chez Romeo Alpha. Nous offrons des opportunités de carrière pour les équipages qualifiés, techniciens et ingénieurs.',
        'SEO Careers Keywords': 'emplois maritimes, recrutement équipage, ingénierie marine, emplois offshore',
        'SEO Contact Title': 'Contactez-Nous - Centre d\'Opérations Maritimes 24h/24 et 7j/7',
        'SEO Contact Desc': 'Contactez Romeo Alpha Maritime. Demandez un devis ou une proposition pour l\'expédition, l\'affrètement, ou la maintenance offshore.',
        'SEO Contact Keywords': 'contact romeo alpha, devis maritime, support port harcourt',
        'SEO Service Maritime Title': 'Services de Transport Maritime et d\'Expédition',
        'SEO Service Maritime Desc': 'Services de transport maritime sûrs et fiables dans les eaux ouest-africaines et internationales. Gestion logistique des cargaisons.',
        'SEO Service Maritime Keywords': 'expédition de fret, transit maritime, transport par navire, fret afrique de l\'ouest',
        'SEO Service Charter Title': 'Affrètement de Navires et Gestion Maritime',
        'SEO Service Charter Desc': 'Services d\'affrètement et de gestion de navires sur mesure. Fourniture d\'équipage qualifié, soutage et inspections de navires.',
        'SEO Service Charter Keywords': 'affrètement de navire, gestion de navire, soutage, inspection de navire',
        'SEO Service Offshore Title': 'Soutien aux Opérations Offshore & Champs Pétroliers',
        'SEO Service Offshore Desc': 'Soutien fiable pour les plateformes offshore, maintenance des plateformes, logistique des champs pétroliers et remorquage.',
        'SEO Service Offshore Keywords': 'support offshore, entretien plateforme, logistique pétrolière, remorqueur',
        'SEO Service Security Title': 'Escorte de Sécurité Maritime et Protection des Actifs',
        'SEO Service Security Desc': 'Sécurité maritime complète, navires d\'escorte armés et évaluations des risques pour le transit en zones à haut risque.',
        'SEO Service Security Keywords': 'sécurité maritime, escorte armée, protection des actifs, évaluation des risques',
        // Service Details
        'Key Operations': 'Opérations Clés',
        'Other Services': 'Autres Services',
        'Charter Operations': 'Opérations d\'Affrètement',
        'Offshore Operations': 'Opérations de Soutien Offshore',
        'Security Operations': 'Opérations de Sécurité',
        'Armed Guards': 'Gardes Armés',
        'Risk Assessment': 'Évaluation des Risques',
        // Partnership Form
        'Partnership Heading': 'Bâtissez avec Romeo Alpha',
        'Partnership Subheading': 'Étendez votre portée maritime grâce à une alliance stratégique.',
        'Label Company': 'Nom de l\'Entreprise',
        'Label Representative': 'Responsable de Contact',
        'Label Email': 'E-mail Professionnel',
        'Label Phone': 'Numéro de Téléphone',
        'Label Interest': 'Secteur d\'Intérêt',
        'Label Message': 'Proposition / Message',
        'Placeholder Company': 'Entrez le nom de votre entreprise',
        'Placeholder Representative': 'Nom complet',
        'Placeholder Email': 'email@entreprise.com',
        'Placeholder Phone': '+234...',
        'Partnership Placeholder Message': 'Décrivez votre vision de partenariat...',
        'Option Shipping': 'Transport et Logistique',
        'Option Technical': 'Services Techniques Marins',
        'Option Security': 'Sécurité Maritime',
        'Option Marketplace': 'Marché des Navires',
        'Option Other': 'Autre Alliance Potentielle',
        'Partnership Success': 'Merci ! Notre équipe de partenariat vous contactera bientôt.',
        'Partnership Btn': 'Envoyer la Proposition',
        'Sending': 'Envoi en cours...',
        // Contact Form
        'Form Success Alert': 'Merci ! Votre message a été envoyé et enregistré.',
        'Placeholder Name': 'Jean Dupont',
        'Placeholder Subject': 'ex. Demande concernant un navire',
        'Placeholder Message': 'Votre message ici...',
        // Marketplace
        'Interested CTA': 'Intéressé à nous contacter',
        'Tag Available': 'Disponible',
        'Tag Marketplace': 'Marché',
        'Tag Featured': 'Vedette',
        // Operation Detail
        'Expertise Heading': 'Notre Expertise',
        'Expertise 1': 'Portée opérationnelle mondiale',
        'Expertise 2': 'Navigation sûre et fiable',
        'Expertise 3': 'Flotte entretenue avec expertise',
        'Expertise 4': 'Professionnels maritimes hautement qualifiés',
        'Inquiry Heading': 'Se Renseigner sur ce Service',
        'Inquiry Placeholder Message': 'Comment pouvons-nous vous aider ?',
        'Inquiry Submit': 'Envoyer la Demande',
        'Images Left': 'images restantes',
        // Team Bios
        'CEO Name': 'Captain Smart-Alli',
        'CEO Title': 'Directeur Général',
        'CEO Quote': '"Notre voyage est défini par la confiance que nous bâtissons en mer et l\'excellence que nous livrons à chaque mille nautique."',
        'CEO Bio 1': 'Plus de trois décennies d\'expérience et d\'expertise dans le transport maritime et l\'industrie pétrolière et gazière.',
        'CEO Bio 2': 'Sa connaissance approfondie du droit maritime international a été déterminante.',
        'James Name': 'Cap. James Sterling',
        'James Bio 1': 'Le Cap. James Sterling apporte une expérience inégalée...',
        'James Bio 2': 'Son leadership garantit l\'exécution de chaque mission avec professionnalisme.',
        'Sarah Name': 'Sarah Okafor',
        'Sarah Bio': 'Experte en coordination logistique offshore et optimisation de la supply chain.',
        'David Name': 'Ing. David Chen',
        'David Bio': 'Ingénieur en chef spécialisé dans la maintenance des navires.',
        'Elena Name': 'Elena Rodriguez',
        'Elena Bio': 'Dédiée au maintien de normes de sécurité de classe mondiale.',
        'Marcus Name': 'Marcus Thorne',
        'Marcus Bio': 'Spécialiste du déploiement des navires et de la gestion des équipages.',
        // Marketplace Detail & Listing
        'Marketplace Loading': 'Chargement des détails...',
        'Item Not Found': 'Article Non Trouvé',
        'Item Error Desc': 'L\'article du marché que vous recherchez n\'existe pas.',
        'Back to Marketplace': 'Retour au Marché',
        'Item Description': 'Description de l\'Article',
        'Key Specifications': 'Spécifications Clés',
        'Label Category': 'Catégorie :',
        'Label Location': 'Localisation :',
        'Label Area': 'Zone :',
        'Label Badges': 'Étiquettes :',
        'Immediate': 'Immédiat',
        'Default Area': 'Port Harcourt, Nigeria',
        'Send Inquiry Detail': 'Envoyer une Demande',
        'Maritime Consultant': 'Consultant Maritime',
        'Consultant Ready': 'Prêt à vous aider pour votre acquisition.',
        'Back': 'Retour',
        'Marketplace Featured': 'Vedette',
        'Marketplace Available': 'Disponible',
        'Enquire': 'S\'informer',
        'Reach out': 'Nous contacter',
        'Price': 'Prix',
        'Service Help Text': 'Vous voulez entretenir des plateformes ou construire des maisons-bateaux ?',
        'See Details': 'Voir les Détails',
        // Admin Dashboard
        'Admin Email Placeholder': 'admin@romeoalpha.com',
        'Access Denied': 'Accès Refusé : Vous n\'avez pas les privilèges d\'administrateur.',
        'Verifying': 'Vérification...',
        'General Error': 'Une erreur est survenue. Veuillez réessayer.',
        'Dashboard Overview': 'Aperçu du Tableau de Bord',
        'Recent Activity': 'Activité Récente',
        'Active Listings': 'Annonces Actives',
        'Vessels for Sale': 'Navires à Vendre',
        'Marine Marketplace': 'Marché Marin',
        'Manage Vessels': 'Gérer les navires à vendre, à louer, réparations et ferrailles.',
        'Add New Item': 'Ajouter un Nouvel Article',
        'Edit Marketplace Item': 'Modifier l\'Article',
        'Save Item': 'Enregistrer l\'Article',
        'Update Item': 'Mettre à jour l\'Article',
        'Cancel': 'Annuler',
        'Title': 'Titre',
        'Category': 'Catégorie',
        'Price Placeholder': 'ex. 1 200 000 ₦ ou Contact pour le Prix',
        'Vessel Status': 'Statut',
        'Vessel Area': 'Zone',
        'Description': 'Description',
        'Badges Placeholder': 'ex. Support, Offshore, Rig Move',
        'Upload Images': 'Télécharger des Images (Max 5)',
        'Item Added Success': 'Article ajouté avec succès !',
        'Item Updated Success': 'Article mis à jour avec succès !',
        'Delete Confirm': 'Êtes-vous sûr de vouloir supprimer cet article ?',
        'Newsletter Hub': 'Centre de Newsletter',
        'Subscriber List': 'Voir et gérer votre liste d\'abonnés',
        'Refresh List': 'Actualiser la Liste',
        'Subscriber Email': 'E-mail de l\'Abonné',
        'Joined Date': 'Date d\'Adhésion',
        'Actions': 'Actions',
        'Remove Subscriber': 'Supprimer l\'abonné de la liste ?',
        'FAQ Management': 'Gestion des FAQ',
        'Add New FAQ': 'Ajouter une FAQ',
        'Question': 'Question',
        'Answer': 'Réponse',
        'Save FAQ': 'Enregistrer la FAQ',
        'Update FAQ': 'Mettre à jour la FAQ',
        'FAQ Delete Confirm': 'Êtes-vous sûr de vouloir supprimer cette FAQ ?',
        'Dashboard': 'Tableau de bord',
        'Newsletter': 'Newsletter',
        'Logout': 'Déconnexion',
        'Admin User': 'Utilisateur Admin',
        'Administrator': 'Administrateur',
        'Headquarters': 'Siège Social',
        'Messages': 'Messages',
        'Manage Messages': 'Voir et gérer les messages entrants',
        'No Messages': 'Aucun message trouvé.',
        'View Message': 'Voir le message',
        'Mark as Read': 'Marquer comme lu',
        'Mark as Unread': 'Marquer comme non lu',
        'No Subject': 'Sans objet',
        'Received Date': 'Date de réception',
        // Marketplace Inquiry
        'Submit Inquiry Title': 'Soumettre une Demande',
        'Full Name': 'Nom Complet',
        'Inquiry Message': 'Message de Demande',
        'Discussion Details': 'Détails de la Discussion',
        'Contact Person': 'Personne de Contact',
        'Sending Request': 'Envoi de la Demande...',
        'Inquiry Success': 'Demande envoyée avec succès !',
        'Inquiry Error': 'Échec de l\'envoi de la demande. Veuillez réessayer.',
        'Close': 'Fermer',
        // Header/Footer & Misc
        'Language': 'Langue',
        'Switch Language': 'Changer de Langue',
        'Explore Our Services': 'Explorez Nos Services',
        'Back to Home': 'Retour à l\'Accueil',
        'Role Head of Operations': 'Chef des Opérations',
        'Role Technical Director': 'Directeur Technique',
        'Label Portharcourt': 'No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'General Message Error': 'Échec de l\'envoi du message. Veuillez réessayer plus tard.',
        'Team Info Heading': 'Notre Direction',
        'Meet the Team': 'Rencontrez l\'Équipe',
        'Lang English': 'English',
        'Lang Spanish': 'Español',
        'Lang French': 'Français',
        'Lang German': 'Deutsch',
        'Lang Chinese': '中文 (Chinese)',
        'Delete': 'Supprimer',
        'Error Label': 'Erreur',
        'Try Refresh': 'Actualiser',
        'Files Selected': 'fichiers sélectionnés',
        'NA': 'N/A',
        'Mass Delete Confirm': 'Êtes-vous sûr de vouloir supprimer ces éléments ?',
        'Delete Success': 'Éléments supprimés avec succès',
        'Form Required Error': 'Le titre et la description sont obligatoires',
        'FAQ Required Error': 'La question et la réponse sont obligatoires',
        'Marketplace Empty State': 'Les articles du marché apparaîtront ici une fois que vous aurez commencé à les ajouter.',
        'FAQ Empty State': 'Aucune FAQ trouvée. Ajoutez-en une pour commencer.',
        'Newsletter Empty State': 'Aucun abonné trouvé.',
        'File Size Error': 'Fichier trop volumineux',
    },
    'de': {
        'Notice Welcome': 'Willkommen bei Romeo Alpha Maritime Consultants and Logistics International Ltd',
        'Home': 'Startseite',
        'About us': 'Über uns',
        'Operations': 'Operationen',
        'Our fleets': 'Marktplatz',
        'Marketplace': 'Marktplatz',
        'Our team': 'Unser Team',
        'Careers': 'Karrieren',
        'Contact us': 'Kontaktieren Sie uns',
        'Get Quotes': 'Angebote einholen',
        'Hero Heading': 'Versand- und Offshore-Operationen antreiben',
        'Hero Subheading': 'Zuverlässige Versand-, Marineicherungs- und Offshore-Öl- und Gasunterstützung in Küsten- und internationalen Gewässern',
        'Browse Operations': 'Erkunden Sie unsere Operationen',
        'Quick Marine Title': 'Marinematerial and Schiffe',
        'Quick Marine Desc': 'Erkunden Sie unser umfangreiches Inventar an Marinematerial und Schiffen zum Verkauf.',
        'Quick Marine Btn': 'Jetzt kaufen',
        'Quick Repair Title': 'Reparaturen and Schrottverkauf',
        'Quick Repair Desc': 'Professionelle Schiffsreparaturdienste und Schrottmetallverkauf.',
        'Quick Repair Btn': 'Jetzt reparieren',
        'Quick Construction Title': 'Marinebau',
        'Quick Construction Desc': 'Fachmännischer Bau von Marineinfrastruktur.',
        'Quick Construction Btn': 'Jetzt bauen',
        'Quick Servicing Title': 'Ölbohrinsel and Plattformwartung',
        'Quick Servicing Desc': 'Umfassende Wartung für Ölbohrtürme und Offshore-Plattformen.',
        'Quick Servicing Btn': 'Jetzt warten',
        'Content Heading': 'Unsere Versand- and Logistiklösungen',
        'Content Subtext': 'Wir bieten integrierte Seeveranstal- and Offshore-Supportdienste.',
        'Banner Heading': 'Lassen Sie uns gemeinsam Geschäfte machen',
        'Banner Subtext': 'Partnern Sie mit uns für Seeveranstal-, Operations- and Sicherheitslösungen.',
        'Banner Button': 'Partnern Sie heute mit uns',
        'Why Romeo Alpha': 'Warum Romeo Alpha?',
        'Why Subtext': 'Wir bieten zuverlässige Marineöl- and Offshore-Lösungen.',
        'Benefit 1 Title': 'Bewährte Marinemachtigung',
        'Benefit 1 Desc': 'Unsere Operationen werden von erfahrenen Marineexperten geleitet.',
        'Benefit 2 Title': 'Zuverlässig and sichere Operationen',
        'Benefit 2 Desc': 'Sicherheit and Zuverlässigkeit sind der Kern unserer Arbeit.',
        'Benefit 3 Title': 'Umfassende Offshore-Unterstützung',
        'Benefit 3 Desc': 'Von Schiffscharter and Frachtverkehr bis Ölfeld-Unterstützung.',
        'Benefit 4 Title': 'Globale Reichweite, lokale Einsicht',
        'Benefit 4 Desc': 'Wir unterstützen Operationen in Küsten- and internationalen Gewässern.',
        'Benefit 5 Title': 'Flexible and skalierbare Lösungen',
        'Benefit 5 Desc': 'Unsere Dienstleistungen sind auf Ihre Betriebsbedürfnisse zugeschnitten.',
        'Benefit 6 Title': 'Partnerschaftsorientierter Ansatz',
        'Benefit 6 Desc': 'Wir arbeiten eng mit Kunden zusammen, um langfristige Partnerschaften aufzubauen.',
        'Services Heading': 'Unsere Dienstleistungen',
        'Services Subheading': 'Wir bieten umfassende Marineöl- and Offshore-Lösungen.',
        'Service 1 Title': 'Schiffsmanagement',
        'Service 1 Desc': 'Unser Ziel ist es, kompetente, sichere and kostengünstige Dienstleistungen zu erbringen.',
        'Service 2 Title': 'Schiffsvermessung and Inspektionen',
        'Service 2 Desc': 'Wir arbeiten daran, die Anforderungen unserer Kunden zu verstehen.',
        'Service 3 Title': 'Maklerdienste',
        'Service 3 Desc': 'Unser Schiffsmakler-Team hat eine bewährte Erfolgsbilanz.',
        'Service 4 Title': 'Chartern',
        'Service 4 Desc': 'Unser Schiffscharter-Team kann das genaue Schiff finden.',
        'Service 5 Title': 'Verkauf von Schrottschiffe',
        'Service 5 Desc': 'Unsere umfangreiche Kenntnis des Schrottmarktes macht uns zur idealen Verkaufsrepräsentanz.',
        'Service 6 Title': 'Besatzung',
        'Service 6 Desc': 'Wir stellen angemessen qualifizierte Besatzung für Schiffe zur Verfügung.',
        'Service 7 Title': 'Bunkerung',
        'Service 7 Desc': 'Unser Unternehmen hat die erforderliche Kapazität, um Schiffsbunkerung anzubieten.',
        'Service 8 Title': 'Projektmanagement and Operationen',
        'Service 8 Desc': 'Wir sorgen dafür, dass Projekte mit einem strukturierten Ansatz gehandhabt werden.',
        'Service 9 Title': 'Marinesicherheit',
        'Service 9 Desc': 'Romeo Alpha bietet umfassende Marinesicherheitslösungen.',
        'Service 10 Title': 'Allgemeine Marine',
        'Service 10 Desc': 'Unsere Allgemeinen Marinedienste zielweise sichere Lösungen ab.',
        'Overlay Maritime': 'Seeveranstal and Betrieb',
        'Overlay Charter': 'Schiffscharter and Verwaltung',
        'Overlay Offshore': 'Offshore and Ölfeldsupport',
        'Overlay Security': 'Marinesicherheit Eskorte',
        'Overlay Repair': 'Schiffsreparatur and Schrottverkauf',
        'Explore Service': 'Erkunden Sie Service',
        'Ads Heading': 'Romeo Alpha kümmert sich um Sie',
        'Ads Subtext': 'Benötigen Sie zuverlässiges Versand? Offshore-Unterstützung on kurze Frist?',
        'Tag Marine': 'Seeveranstal',
        'Tag Offshore': 'Offshore-Unterstützung',
        'Tag Charter': 'Schiffscharter',
        'Tag Security': 'Marinesicherheit Eskorte',
        'Tag Logistics': 'Öl and Gas Logistik',
        'Tag Global': 'Globale Operationen',
        'FAQ Title': 'Häufig gestellte Fragen',
        'FAQ_Q1': 'Welche Marinedienstleistungen bietet Romeo Alpha an?',
        'FAQ_A1': 'Romeo Alpha bietet umfassende Marinedienstleistungen wie Schiffscharter, Offshore-Unterstützung, Marinesicherheitseskorte, Schiffsmaklergeschäfte, Frachtlogistik, Flottenmanagement sowie Offshore-Öl- und Gasoperationen an.',
        'FAQ_Q2': 'In welchen Gebieten sind Sie tätig?',
        'FAQ_A2': 'Wir operieren weltweit auf wichtigen Schifffahrtsrouten. Unsere Schwerpunkte liegen in westafrikanischen Gewässern, dem Golf von Guinea, dem Mittelmeer und internationalen Schifffahrtsrouten zwischen Afrika, Europa und Amerika.',
        'FAQ_Q3': 'Wie kann ich ein Angebot anfordern?',
        'FAQ_A3': 'Sie können ein Angebot über die Schaltfläche "Angebote einholen", per E-Mail oder über unser operatives Zentrum anfordern. Unser Team antwortet in der Regel innerhalb von 24 Stunden.',
        'FAQ_Q4': 'Welche Schiffstypen befinden sich in Ihrer Flotte?',
        'FAQ_A4': 'Unsere Flotte umfasst Offshore-Versorger (OSV), Ankerziehschlepper (AHTS), Plattformversorger (PSV), Mannschaftsboote, Schlepper und Sicherheitsbegleitschiffe. Alle entsprechen den internationalen Standards.',
        'FAQ_Q5': 'Bieten Sie operative Unterstützung rund um die Uhr an?',
        'FAQ_A5': 'Ja, wir unterhalten einen 24/7-Betrieb mit einem engagierten Support-Team. Unser Betriebszentrum überwacht alle aktiven Schiffe und kann jederzeit auf Notfälle reagieren.',
        'FAQ_Q6': 'Welche Sicherheitszertifizierungen besitzen Sie?',
        'FAQ_A6': 'Romeo Alpha besitzt die ISM-Code-Zertifizierung, ISO 9001:2015 für Qualitätsmanagement und erfüllt die Anforderungen von SOLAS, MARPOL und ISPS-Code.',
        'FAQ_Q7': 'Wie kann ich Partner von Romeo Alpha werden?',
        'FAQ_A7': 'Wir begrüßen Partnerschaften mit Reedereien, Öl- und Gasbetreibern sowie Marinedienstleistern. Kontaktieren Sie unser Geschäftsentwicklungsteam über unsere Kontaktseite.',
        'Proof Vessels': '150+',
        'Proof Vessels Text': 'Aktive and verwaltete Schiffe',
        'Proof Countries': '50+',
        'Proof Countries Text': 'Länder in globalen Gewässern bedient',
        'Proof Support': '24/7',
        'Proof Support Text': 'Marine and Offshore Operations Unterstützung',
        'Footer Subscribe Heading': 'Abonnieren Sie unseren Newsletter',
        'Footer Subscribe Btn': 'Abonnieren',
        'Footer Business Heading': 'Geschäfte zusammen machen',
        'Footer Link What': 'Was wir tun',
        'Footer Link Fleets': 'Marktplatz',
        'Footer Link Offshore': 'Offshore-Dienste',
        'Footer Link Security': 'Marinesicherheit',
        'Footer Link Charter': 'Schiffscharter and Verwaltung',
        'Footer Link Partnership': 'Partnerschaften',
        'Admin Login': 'Admin Login',
        'Secure Access': 'Geben Sie Ihre Anmeldedaten ein',
        'Email Address': 'E-Mail-Addresse',
        'Password': 'Passwort',
        'Login': 'Anmelden',
        'Footer Know Heading': 'Lernen Sie uns kennen',
        'Footer Link About': 'Über Romeo Alpha',
        'Footer Link News': 'Nachrichten and Einblicke',
        'Footer Link Careers': 'Karrieren',
        'Footer Link Contact': 'Kontaktieren Sie uns',
        'Footer Address': 'Headquarters - +2348066184330 / +2348055769660 - info@romeoalphamaritime.com / Kyoyan99@yahoo.com - No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'CAC Registration': 'RC: 9257242 - Eingetragen bei der Corporate Affairs Commission (CAC)',
        'Scroll Top': 'Oben',
        'Unread': 'Ungelesen',
        'About Hero Title': 'Über Romeo Alpha',
        'About Hero Subtitle': 'Anführung im globalen Marinemitgliedschafts and Offshore-Exzellenz.',
        'Mission Title': 'Unsere Mission',
        'Mission Text': 'Sichere, zuverlässige and effiziente Seeveranstal and Offshore-Unterstützungsdienste bereitstellen.',
        'Vision Title': 'Unsere Vision',
        'Vision Text': 'Der bevorzugte globale Partner in der Marinebranche sein.',
        'Who We Are Title': 'Wer wir sind',
        'Who We Are Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd ist ein führender Anbieter von Seeveranstal and Offshore-Unterstützungsdienste.',
        'Who We Are Desc 2': 'Gegründet auf den Grundsätzen der Integrität and Sicherheit sind wir ein vertrauenswürdiger Name in der Branche.',
        'Stat Years': '10+',
        'Stat Years Label': 'Jahre Erfahrung',
        'Stat Vessels': '150+',
        'Stat Vessels Label': 'Verwaltete Schiffe',
        'Stat Partners': '50+',
        'Stat Partners Label': 'Globale Partner',
        'Get in touch': 'Kontakt aufnehmen',
        'Fleets Hero Title': 'Unsere globale Flotte',
        'Fleets Hero Subtitle': 'Eine vielseitige and moderne Flotte für Sicherheit and Effizienz.',
        'Fleet Overview Title': 'Flottenübersicht',
        'Fleet Overview Desc': 'Romeo Alpha verwaltet ein vielfältiges Portfolio von Schiffen.',
        'Total Vessels': 'Gesamtschiffe',
        'Vessel Types': 'Schiffstypen',
        'Avg Age': 'Durchschnittliches Alter',
        'Cat Offshore': 'Offshore-Unterssttungungsschiffe',
        'Cat Cargo': 'Fracht and Tankerschiff',
        'View Spec': 'Spezifikationen anzeigen',
        'Team Hero Title': 'Treffen Sie unsere Führer',
        'Team Hero Subtitle': 'Die erfahrenen Fachleute, die Marineexzellenz vorantreiben.',
        'Team Intro': 'Bei Romeo Alpha wird unser Erfolg durch die Expertise and Führung unserer Mitarbeiter vorangetrieben.',
        'Founder Label': 'GRÜNDER and VISIONÄR',
        'MD Label': 'GESCHÄFTSFÜHRER',
        'Core Team Title': 'Kernführungsteam',
        'CEO Name': 'Captain Smart-Alli',
        'CEO Title': 'Geschäftsführer (CEO)',
        'CEO Quote': '"Unsere Reise ist definiert durch das Vertrauen, das wir auf See aufbauen, und die Exzellenz, die wir in jeder nautischen Meile liefern."',
        'CEO Bio 1': 'Über drei Jahrzehnte Erfahrung und Fachwissen im Seetransport sowie in der Öl- und Gasindustrie.',
        'CEO Bio 2': '',
        'Join Team Title': 'Wollen Sie unserem Team beitreten?',
        'Join Team Subtitle': 'Wir suchen ständig talentierte Personen.',
        'See Openings': 'Karrieremöglichkeiten sehen',
        'Ans Header': 'Antwort',
        'FAQ Header': 'FAQs',
        'Search Placeholder': 'Nach einem Dienst suchen...',
        'Category All': 'Alle Dienstleistungen',
        'Category Offshore': 'Zu verkaufen',
        'Category Logistics': 'Zu vermieten',
        'Category Charter': 'Reparatur',
        'Category Port': 'Verschrottung',
        'Marketplace Sale': 'Zu verkaufen',
        'Marketplace Hire': 'Zu vermieten',
        'Marketplace Repair': 'Reparatur',
        'Marketplace Scrap': 'Verschrottung',
        'No Results': 'Keine Operationen gefunden.',
        'Operations Page Title': 'Marine Marktplatz',
        'Operations Page Subtitle': 'Erkunden Sie Schiffe zum Verkauf, zur Neuvermietung, Reparatur and Verschrottung.',
        'Contact Hero Title': 'Kontaktiere uns',
        'Contact Hero Subtitle': 'Wir sind da, um Ihnen bei Ihren Marinebrauchen zu helfen.',
        'Visit Office Heading': 'Besuchen Sie unser Büro',
        'Lets Talk Heading': 'Lassen Sie uns sprechen',
        'Call Us CTA': 'Rufen Sie uns an',
        'Inbox Heading': 'Posteingang',
        'Email Us CTA': 'Email uns',
        'Support Text': 'Kontaktieren Sie uns and lassen Sie uns wissen, wie wir helfen können.',
        'About Btn': 'Über Unternehmen',
        'Form Title': 'Senden Sie uns eine Nachricht',
        'Form Name': 'Vollständiger Name',
        'Form Email': 'E-Mail-Addresse',
        'Form Subject': 'Betreff',
        'Form Message': 'Nachricht',
        'Form Submit': 'Nachricht senden',
        'Careers Hero Title': 'Treten Sie unserem Team bei',
        'Careers Hero Subtitle': 'Bauen Sie Ihre Zukunft mit einem globalen Marineführer auf.',
        'Careers Label': 'KARRIEREN',
        'Working Title': 'Arbeiten bei Romeo Alpha',
        'Working P1': 'Bei Romeo Alpha sind unsere Mitarbeiter das Fundament unseres Erfolgs.',
        'Working P2': 'Wir sind stolz auf unser Engagement for Sicherheit and Wohlbefinden.',
        'Get In Touch': 'Kontakt aufnehmen',
        'Recruitment Title': 'Rekrutierung',
        'Recruitment P1': 'Unser Rekrutierungsprozess ist strukturiert, um die besten Talente zu identifizieren.',
        'Recruitment P2': 'Wir suchen ständig nach Personen, die unsere Vision for Exzellenz teilen.',
        'Related Subtitle': 'Erkunden Sie andere Dienste',
        'Logo Alt': 'Unternehmenslogo',
        'Email Placeholder': 'E-Mail',
        'Copyright': '© 2026 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        // SEO Metadata
        'SEO Home Title': 'Schiffsversand, Offshore-Support & Marine-Eskorte',
        'SEO Home Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd bietet Schiffscharterung, Offshore-Support, Sicherheitsbegleitung, Schiffsreparaturen und Schrottverkauf.',
        'SEO Home Keywords': 'maritim, schifffahrt, offshore-unterstützung, sicherheitsbegleitschiff, schiffscharter, schiffsmanagement',
        'SEO About Title': 'Über Uns - Globale Spezialisten für Maritime Logistik',
        'SEO About Desc': 'Erfahren Sie mehr über Romeo Alpha Maritime, unsere Mission, Vision, Flottenkapazität und unser Engagement für den globalen Seetransport.',
        'SEO About Keywords': 'über romeo alpha, schiffscrew, marineberater, maritime compliance',
        'SEO Marketplace Title': 'Maritimer Marktplatz - Schiffe zum Verkauf, zur Miete & Schrott',
        'SEO Marketplace Desc': 'Erkunden Sie unseren maritimen Marktplatz. Kaufen oder mieten Sie Offshore-Unterstützungsschiffe, Schlepper, Schiffsreparaturen und Schrott.',
        'SEO Marketplace Keywords': 'schiff kaufen, schlepper mieten, marineschrott, schiffsreparatur',
        'SEO Team Title': 'Unser Führungsteam - Erfahrene Kapitäne',
        'SEO Team Desc': 'Lernen Sie unser Führungsteam um Kapitän Smart-Alli und Kapitän James Sterling kennen, die über jahrzehntelange Erfahrung im Seetransport verfügen.',
        'SEO Team Keywords': 'kapitän smart-alli, schiffskapitän, maritime führung',
        'SEO Careers Title': 'Karriere - Werden Sie Teil Unseres Teams',
        'SEO Careers Desc': 'Bauen Sie Ihre Zukunft bei Romeo Alpha auf. Wir bieten Karrierechancen für qualifizierte Besatzungen, Offshore-Techniker und Ingenieure.',
        'SEO Careers Keywords': 'maritime jobs, heuer, offshore-karriere, schiffsingenieurwesen',
        'SEO Contact Title': 'Kontakt - 24/7 Maritimes Operationszentrum',
        'SEO Contact Desc': 'Kontaktieren Sie Romeo Alpha Maritime. Fordern Sie ein Angebot für Versand, Schiffscharterung, maritime Sicherheit oder Plattformwartung an.',
        'SEO Contact Keywords': 'kontakt romeo alpha, angebot anfordern, schiffseigner anfragen',
        'SEO Service Maritime Title': 'Seetransport- und Versanddienstleistungen',
        'SEO Service Maritime Desc': 'Sichere und zuverlässige Seetransporte in westafrikanischen und internationalen Gewässern. Frachtlogistikmanagement.',
        'SEO Service Maritime Keywords': 'frachtschifffahrt, seetransit, schiffstransport, schifffahrt westafrika',
        'SEO Service Charter Title': 'Schiffscharterung und Schiffsmanagement',
        'SEO Service Charter Desc': 'Maßgeschneiderte Schiffscharter- und Schiffsmanagementdienste. Bereitstellung qualifizierter Crew, Bunkern und Schiffsinspektionen.',
        'SEO Service Charter Keywords': 'schiffscharter, schiffsmanagement, bunkern, schiffsinspektion',
        'SEO Service Offshore Title': 'Unterstützung von Offshore- & Ölfeldoperationen',
        'SEO Service Offshore Desc': 'Zuverlässige Unterstützung für Offshore-Plattformen, Wartung von Bohrinseln, Ölfeldlogistik, Schleppdienste und Ankerhandling.',
        'SEO Service Offshore Keywords': 'offshore-support, bohrinselwartung, ölfeldlogistik, ankerhandhabung',
        'SEO Service Security Title': 'Maritime Sicherheitsbegleitung und Vermögensschutz',
        'SEO Service Security Desc': 'Umfassende maritime Sicherheit, bewaffnete Begleitschiffe und Risikobewertungen für den Transit durch Hochrisikogebiete.',
        'SEO Service Security Keywords': 'maritime sicherheit, bewaffnetes begleitschiff, vermögensschutz, risikobewertung',
        'Key Operations': 'Taeutigkeitsschlüssel',
        'Other Services': 'Andere Dienste',
        'Charter Operations': 'Charter-Operationen',
        'Offshore Operations': 'Offshore-Unterstützungsoperationen',
        'Security Operations': 'Sicherungsoperationen',
        'Armed Guards': 'Bewaffnete Wächter',
        'Risk Assessment': 'Risikobewertung',
        'Partnership Heading': 'Bauen Sie mit Romeo Alpha',
        'Partnership Subheading': 'Erweitern Sie Ihre Marinreichweite durch eine strategische Allianz.',
        'Label Company': 'Unternehmensname',
        'Label Representative': 'Kontakt Vertreter',
        'Label Email': 'Geschäfts-E-Mail',
        'Label Phone': 'Telefonnummer',
        'Label Interest': 'Interessensgebiet',
        'Label Message': 'Vorschlag / Nachricht',
        'Placeholder Company': 'Geben Sie Ihren Unternehmensname ein',
        'Placeholder Representative': 'Vollständiger Name',
        'Placeholder Email': 'email@company.com',
        'Placeholder Phone': '+234...',
        'Partnership Placeholder Message': 'Beschreiben Sie Ihre Partnerschaftsvision...',
        'Option Shipping': 'Versand and Logistik',
        'Option Technical': 'Marine Technische Dienstleistungen',
        'Option Security': 'Marinesicherheit',
        'Option Marketplace': 'Schiff Marktplatz',
        'Option Other': 'Andere potenzielle Allianz',
        'Partnership Success': 'Danke! Unser Partnerschaftsteam wird Sie bald kontaktieren.',
        'Partnership Btn': 'Senden Sie Partnerschaftsvorschlag',
        'Sending': 'Versenden...',
        'Form Success Alert': 'Vielen Dank! Ihre Nachricht wurde an unser Team gesendet.',
        'Placeholder Name': 'John Doe',
        'Placeholder Subject': 'Anfrage zu...',
        'Placeholder Message': 'Ihre Nachricht hier...',
        'Interested CTA': 'Interessiert am Erreichen',
        'Tag Available': 'Verfügbar',
        'Tag Marketplace': 'Marktplatz',
        'Tag Featured': 'Featured',
        'Expertise Heading': 'Unsere Expertise',
        'Expertise 1': 'Globale operativ Reichweite',
        'Expertise 2': 'Sichere and zuverlässige Navigation',
        'Expertise 3': 'Fachkundig gepflegte Schiffsflotte',
        'Expertise 4': 'Hochqualifizierte Marineexperten',
        'Inquiry Heading': 'Fragen Sie nach diesem Dienst',
        'Inquiry Btn': 'Anfrage abrufen',
        'Show More': 'Mehr anzeigen',
        'Show Less': 'Weniger anzeigen',
        'Label Portharcourt': 'No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'General Message Error': 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut.',
        'Team Info Heading': 'Unsere Führung',
        'Meet the Team': 'Treffen Sie das Team',
        'Lang English': 'English',
        'Lang Spanish': 'Español',
        'Lang French': 'Français',
        'Lang German': 'Deutsch',
        'Lang Chinese': '中文 (Chinese)',
        'Delete': 'Löschen',
        'Administrator': 'Administrator',
        'Headquarters': 'Zentrale',
        'Messages': 'Nachrichten',
        'Manage Messages': 'Eingehende Nachrichten anzeigen und verwalten',
        'No Messages': 'Keine Nachrichten gefunden.',
        'View Message': 'Nachricht anzeigen',
        'Mark as Read': 'Als gelesen markieren',
        'Mark as Unread': 'Als ungelesen markieren',
        'No Subject': 'Kein Betreff',
        'Received Date': 'Empfangsdatum',
        'Error Label': 'Fehler',
        'Try Refresh': 'Aktualisieren',
        'Files Selected': 'Dateien ausgewählt',
        'NA': 'N/V',
        'Mass Delete Confirm': 'Sind Sie sicher, dass Sie diese Elemente löschen möchten?',
        'Delete Success': 'Elemente erfolgreich gelöscht',
        'Form Required Error': 'Titel and Beschreibung sind erforderlich',
        'FAQ Required Error': 'Frage and Antwort sind erforderlich',
        'Marketplace Empty State': 'Marktplatzartikel werden hier angezeigt, sobald Sie mit dem Hinzufügen beginnen.',
        'FAQ Empty State': 'Keine FAQ gefunden. Fügen Sie eine hinzu, um zu beginnen.',
        'Newsletter Empty State': 'Keine Abonnenten gefunden.',
        'File Size Error': 'Datei zu groß',
    },
    'zh': {
        'Notice Welcome': '欢迎来到 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        'Home': '首页',
        'About us': '关于我们',
        'Operations': '操作',
        'Our fleets': '市场',
        'Marketplace': '市场',
        'Our team': '我们的团队',
        'Careers': '职业',
        'Contact us': '联系我们',
        'Get Quotes': '获取报价',
        'Hero Heading': '推动海上运输和离岸业务',
        'Hero Subheading': '在沿海和国际水域提供安全可靠的航运、海上安全护送和海上石油和天然气支持',
        'Browse Operations': '浏览我们的操作',
        'Quick Marine Title': '海洋设备和船舶',
        'Quick Marine Desc': '浏览我们销售的海洋设备和船舶的广泛库存。',
        'Quick Marine Btn': '现在购买',
        'Quick Repair Title': '修复and废品销售',
        'Quick Repair Desc': '专业的船舶修理服务and废金属销售。',
        'Quick Repair Btn': '立即修复',
        'Quick Construction Title': '海洋结构建筑',
        'Quick Construction Desc': '专业建造海洋基础设施。',
        'Quick Construction Btn': '现在建造',
        'Quick Servicing Title': '油钻机and平台服务',
        'Quick Servicing Desc': '为油钻机and海上平台提供综合服务。',
        'Quick Servicing Btn': '现在维修',
        'Content Heading': '我们的航运and物流解决方案',
        'Content Subtext': '我们提供综合海上运输and离岸支持服务。',
        'Banner Heading': '让我们一起做生意',
        'Banner Subtext': '与我们合作进行海上运输、业务and安全解决方案。',
        'Banner Button': '今天与我们合作',
        'Why Romeo Alpha': '为什么选择Romeo Alpha?',
        'Why Subtext': '我们提供基于经验、安全and长期合作的可靠海洋and离岸解决方案。',
        'Benefit 1 Title': '久经考验的海洋专业知识',
        'Benefit 1 Desc': '我们的运营由经验丰富的海洋专业人士领导。',
        'Benefit 2 Title': '可靠and安全的运营',
        'Benefit 2 Desc': '安全and可靠性是我们所做一切的核心。',
        'Benefit 3 Title': '端到端离岸支持',
        'Benefit 3 Desc': '从船舶租赁and货运到离岸钻井平台支持。',
        'Benefit 4 Title': '全球覆盖，本地洞察',
        'Benefit 4 Desc': '我们在沿海and国际水域提供运营支持。',
        'Benefit 5 Title': '灵活and可扩展的解决方案',
        'Benefit 5 Desc': '我们的服务根据您的业务需求进行定制。',
        'Benefit 6 Title': '以合作为导向的方法',
        'Benefit 6 Desc': '我们与客户紧密合作，建立长期合作关系。',
        'Services Heading': '我们的服务',
        'Services Subheading': '我们提供综合海洋、离岸and物流解决方案。',
        'Service 1 Title': '船舶管理',
        'Service 1 Desc': '我们的目标是提供胜任、安全and经济高效的服务。',
        'Service 2 Title': '船舶测量and检查',
        'Service 2 Desc': '我们花时间了解我们客户的需求。',
        'Service 3 Title': '经纪服务',
        'Service 3 Desc': '我们的船舶经纪团队具有卓越的服务记录。',
        'Service 4 Title': '租赁',
        'Service 4 Desc': '我们的船舶租赁团队可以找到精确的船舶。',
        'Service 5 Title': '废旧船舶销售',
        'Service 5 Desc': '我们对旧船市场的了解使我们成为理想的销售代表。',
        'Service 6 Title': '配员',
        'Service 6 Desc': '我们为船舶配备适当合格的船员。',
        'Service 7 Title': '燃油供应',
        'Service 7 Desc': '我们的公司具有提供海上加油and燃油供应的必要能力。',
        'Service 8 Title': '项目管理and业务',
        'Service 8 Desc': '我们确保项目通过结构化方法进行处理。',
        'Service 9 Title': '海上安全',
        'Service 9 Desc': 'Romeo Alpha提供全面的海上安全解决方案。',
        'Service 10 Title': '常规海上',
        'Service 10 Desc': '我们的常规海上服务旨在提供安全可靠的海上解决方案。',
        'Overlay Maritime': '海上运输and业务',
        'Overlay Charter': '船舶租赁and管理',
        'Overlay Offshore': '离岸and油田支持',
        'Overlay Security': '海上安全护送',
        'Overlay Repair': '船舶修理and废品销售',
        'Explore Service': '浏览服务',
        'Ads Heading': 'Romeo Alpha已经为您准备好了',
        'Ads Subtext': '需要可靠的航运?短期内的离岸支持?关键货物的安全护送?',
        'Tag Marine': '海上运输',
        'Tag Offshore': '离岸支持',
        'Tag Charter': '船舶租赁',
        'Tag Security': '海上安全护送',
        'Tag Logistics': '石油and天然气物流',
        'Tag Global': '全球业务',
        'FAQ Title': '常见问题解答',
        'FAQ_Q1': 'Romeo Alpha 提供哪些海事服务？',
        'FAQ_A1': 'Romeo Alpha 提供全面的海事服务，包括船舶租赁、离岸支持、海上安全护送服务、船舶经纪、货物物流、船队管理以及沿海和国际水域的离岸石油和天然气业务。',
        'FAQ_Q2': '你们在哪些地区开展业务？',
        'FAQ_A2': '我们在全球主要航运路线和离岸地点开展业务。我们的主要覆盖范围包括西非水域、几内亚湾、地中海以及连接非洲、欧洲和美洲的国际航线。',
        'FAQ_Q3': '我如何申请服务报价？',
        'FAQ_A3': '您可以通过点击网站上的“获取报价”按钮、发送电子邮件或致电我们的 24/7 运营中心来申请报价。我们的团队通常会在 24 小时内回复。',
        'FAQ_Q4': '你们的船队有哪些类型的船舶？',
        'FAQ_A4': '我们的船队包括离岸支持船 (OSV)、抛锚供应船 (AHTS)、平台供应船 (PSV)、船员船、拖船和安全护送船。所有船舶均符合国际海事标准。',
        'FAQ_Q5': '你们提供 24/7 全天候运营支持吗？',
        'FAQ_A5': '是的，我们拥有专门的支持团队，维持 24/7 全天候运营。我们的运营中心监控所有活跃船舶，并能随时应对紧急情况。',
        'FAQ_Q6': '您拥有哪些安全认证？',
        'FAQ_A6': 'Romeo Alpha 拥有 ISM 代码认证、ISO 9001:2015 质量管理体系认证，并符合 SOLAS、MARPOL 和 ISPS 代码要求。',
        'FAQ_Q7': '我如何与 Romeo Alpha 建立伙伴关系？',
        'FAQ_A7': '我们欢迎与航运公司、石油和天然气运营商建立合伙伴关系。请通过我们的联系页面与业务发展团队联系。',
        'Proof Vessels': '150+',
        'Proof Vessels Text': '活跃and受管船舶',
        'Proof Countries': '50+',
        'Proof Countries Text': '全球水域服务的国家',
        'Proof Support': '24/7',
        'Proof Support Text': '海洋and离岸业务支持',
        'Footer Subscribe Heading': '订阅我们的新闻稿',
        'Footer Subscribe Btn': '订阅',
        'Footer Business Heading': '一起做生意',
        'Footer Link What': '我们做什么',
        'Footer Link Fleets': '市场',
        'Footer Link Offshore': '离岸服务',
        'Footer Link Security': '海上安全',
        'Footer Link Charter': '船舶租赁and管理',
        'Footer Link Partnership': '合作伙伴关系',
        'Admin Login': '管理员登录',
        'Secure Access': '输入您的凭据',
        'Email Address': '电子邮件地址',
        'Password': '密码',
        'Login': '登录',
        'Footer Know Heading': '了解我们',
        'Footer Link About': '关于Romeo Alpha',
        'Footer Link News': '新闻and见解',
        'Footer Link Careers': '职业',
        'Footer Link Contact': '联系我们',
        'Footer Address': '总部 - +2348066184330 / +2348055769660 - info@romeoalphamaritime.com / Kyoyan99@yahoo.com - No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'Scroll Top': '顶部',
        'Unread': '未读',
        'About Hero Title': '关于Romeo Alpha',
        'About Hero Subtitle': '引领全球海洋解决方案and离岸卓越',
        'Mission Title': '我们的使命',
        'Mission Text': '提供安全、可靠and高效的海上运输and离岸支持服务。',
        'Vision Title': '我们的愿景',
        'Vision Text': '成为海洋业的首选全球合作伙伴。',
        'Who We Are Title': '我们是谁',
        'Who We Are Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd是海上运输and离岸支持服务的领先提供商。',
        'Who We Are Desc 2': '基于诚信和安全原则，我们已成为业界的可信名称。',
        'Stat Years': '10+',
        'Stat Years Label': '年经验',
        'Stat Vessels': '150+',
        'Stat Vessels Label': '管理的船舶',
        'Stat Partners': '50+',
        'Stat Partners Label': '全球合作伙伴',
        'Get in touch': '接触',
        'Fleets Hero Title': '我们的全球船队',
        'Fleets Hero Subtitle': '为安全、效率and全球覆盖而设计的多功能and现代船队。',
        'Fleet Overview Title': '船队概览',
        'Fleet Overview Desc': 'Romeo Alpha管理着多样化的船舶组合。',
        'Total Vessels': '船舶总数',
        'Vessel Types': '船舶类型',
        'Avg Age': '平均年龄',
        'Cat Offshore': '离岸支持船',
        'Cat Cargo': '货运and油轮货轮',
        'View Spec': '查看规格',
        'Team Hero Title': '认识我们的领导者',
        'Team Hero Subtitle': '推动海洋卓越的经验丰富的专业人士。',
        'Team Intro': '在Romeo Alpha，我们的成功建立在我们人民的专业知识and领导力之上。',
        'Founder Label': '创始人and远见卓识',
        'MD Label': '常务董事',
        'Core Team Title': '核心领导团队',
        'CEO Name': 'Captain Smart-Alli',
        'CEO Title': '首席执行官',
        'CEO Quote': '“我们的航程取决于我们在海上建立的信任，以及我们在每一海里交付的卓越。”',
        'CEO Bio 1': '在海上运输和石油天然气行业拥有超过三十年的近海经验和专长。',
        'CEO Bio 2': '',
        'Join Team Title': '想加入我们的团队吗?',
        'Join Team Subtitle': '我们一直在寻找有才华的人加入我们。',
        'See Openings': '查看职业机会',
        'Ans Header': '答案',
        'FAQ Header': '常见问题',
        'Search Placeholder': '搜索服务...',
        'Category All': '所有服务',
        'Category Offshore': '待售',
        'Category Logistics': '出租',
        'Category Charter': '修理',
        'Category Port': '废品',
        'Marketplace Sale': '待售',
        'Marketplace Hire': '出租',
        'Marketplace Repair': '修理',
        'Marketplace Scrap': '废品',
        'No Results': '未找到任何操作。',
        'Operations Page Title': '海洋市场',
        'Operations Page Subtitle': '探索待售、出租、维修and报废的船舶。',
        'Contact Hero Title': '取得联系',
        'Contact Hero Subtitle': '我们在这里帮助您解决海上and离岸需求。',
        'Visit Office Heading': '访问我们的办公室',
        'Lets Talk Heading': '让我们交谈',
        'Call Us CTA': '给我们打电话',
        'Inbox Heading': '收件箱',
        'Email Us CTA': '给我们发邮件',
        'Support Text': '与我们联系，让我们知道我们如何可以帮助。',
        'About Btn': '关于公司',
        'Form Title': '给我们发消息',
        'Form Name': '全名',
        'Form Email': '电子邮件地址',
        'Form Subject': '主题',
        'Form Message': '消息',
        'Form Submit': '发送消息',
        'Careers Hero Title': '加入我们的团队',
        'Careers Hero Subtitle': '与全球海洋领导者一起建立您的未来。',
        'Careers Label': '职业',
        'Working Title': '在Romeo Alpha工作',
        'Working P1': '在Romeo Alpha，我们的员工是我们成功的基础。',
        'Working P2': '我们以对安全and员工福利的承诺而自豪。',
        'Get In Touch': '取得联系',
        'Recruitment Title': '招募',
        'Recruitment P1': '我们的招聘流程旨在识别行业中最优秀的人才。',
        'Recruitment P2': '我们不断寻找分享我们卓越愿景的人员。',
        'Related Subtitle': '探索其他服务',
        'Logo Alt': '公司徽标',
        'Email Placeholder': '电子邮件',
        'Copyright': '© 2026 Romeo Alpha Maritime Consultants and Logistics International Ltd',
        // SEO Metadata
        'SEO Home Title': '船舶运输、离岸支持与海上安全护送',
        'SEO Home Desc': 'Romeo Alpha Maritime Consultants and Logistics International Ltd 提供全球船舶租赁、离岸支持、海上安全护送、船舶维修和废船销售服务。',
        'SEO Home Keywords': '海事, 航运, 离岸油气支持, 安全护送船, 船舶租赁, 船舶管理, 海事咨询',
        'SEO About Title': '关于我们 - 全球海事物流专家',
        'SEO About Desc': '了解 Romeo Alpha Maritime、我们的使命、愿景、船队实力，以及我们对全球海上运输和海上油气钻井平台支持的承诺。',
        'SEO About Keywords': '关于罗密欧阿尔法, 船员, 船长, 海事顾问, 海事合规',
        'SEO Marketplace Title': '海事市场 - 船舶买卖、租赁与废品销售',
        'SEO Marketplace Desc': '探索我们的海事市场。购买或租赁离岸支持船、拖船，获取船舶修理、海上结构物建造和金属废品销售服务。',
        'SEO Marketplace Keywords': '购买船舶, 租赁拖船, 船用废钢, 船舶修理, 钻井平台服务',
        'SEO Team Title': '我们的领导团队 - 经验丰富的远洋船长',
        'SEO Team Desc': '引荐我们的领导团队，包括 Smart-Alli 船长和 James Sterling 船长，他们拥有数十年的深海航行和海事运营管理经验。',
        'SEO Team Keywords': 'Smart-Alli 船长, 远洋船长, 海事领导者, 航运管理',
        'SEO Careers Title': '职业生涯 - 加入我们的海事与离岸团队',
        'SEO Careers Desc': '在 Romeo Alpha 规划您的未来。我们为合格的船员、离岸技术人员和海事工程师提供丰厚的职业发展机会。',
        'SEO Careers Keywords': '海事招聘, 船员招募, 离岸职业, 海事工程, 船舶工作',
        'SEO Contact Title': '联系我们 - 24/7 海事运营中心',
        'SEO Contact Desc': '联系 Romeo Alpha Maritime。申请航运、船舶租赁、海上安全或钻井平台维护的报价或提案。',
        'SEO Contact Keywords': '联系罗密欧阿尔法, 索取报价, 哈科特港海事支持, 船东咨询',
        'SEO Service Maritime Title': '海上运输与航运服务',
        'SEO Service Maritime Desc': '在西非和国际水域提供安全可靠的海上运输服务。管理干货和液态货物航运物流。',
        'SEO Service Maritime Keywords': '货物运输, 海上转转, 船舶运输, 西非航运',
        'SEO Service Charter Title': '船舶租赁与船舶管理',
        'SEO Service Charter Desc': '量身定制的船舶租赁和船舶管理服务。提供合格船员配备、海上加油（加油服务）及船舶检验。',
        'SEO Service Charter Keywords': '船舶租赁, 船舶管理, 船舶加油, 船舶检验, 船员配备',
        'SEO Service Offshore Title': '离岸与油田运营支持',
        'SEO Service Offshore Desc': '为离岸平台、钻井平台维护、油田物流、起锚和拖航服务提供可靠的支持。',
        'SEO Service Offshore Keywords': '离岸支持, 钻井平台维护, 油田物流, 抛锚工拖船',
        'SEO Service Security Title': '海上安全护送与资产保护',
        'SEO Service Security Desc': '全面的海事安全解决方案、武装护航船只，以及通过高风险离岸区域 of 风险评估。',
        'SEO Service Security Keywords': '海上安全, 武装护航船, 海事保护, 风险评估',
        'Key Operations': '关键操作',
        'Other Services': '其他服务',
        'Charter Operations': '租赁操作',
        'Offshore Operations': '离岸支持业务',
        'Security Operations': '安全操作',
        'Armed Guards': '武装警卫',
        'Risk Assessment': '风险评估',
        'Partnership Heading': '与Romeo Alpha建立',
        'Partnership Subheading': '通过战略联盟扩展您的海洋业务范围。',
        'Label Company': '公司名称',
        'Label Representative': '联系代表',
        'Label Email': '企业电子邮件',
        'Label Phone': '电话号码',
        'Label Interest': '兴趣服务领域',
        'Label Message': '提案/消息',
        'Placeholder Company': '输入您的公司名称',
        'Placeholder Representative': '全名',
        'Placeholder Email': 'email@company.com',
        'Placeholder Phone': '+234...',
        'Partnership Placeholder Message': '描述您的合伙愿景...',
        'Option Shipping': '航运and物流',
        'Option Technical': '海洋技术服务',
        'Option Security': '海上安全',
        'Option Marketplace': '船舶市场',
        'Option Other': '其他潜在联盟',
        'Partnership Success': '谢谢!我们的合作团队将很快与您联系。',
        'Partnership Btn': '发送合伙提案',
        'Sending': '发送...',
        'Form Success Alert': '谢谢!您的消息已发送给我们的团队。',
        'Placeholder Name': 'John Doe',
        'Placeholder Subject': '有关...的查询',
        'Placeholder Message': '您的消息在这里...',
        'Interested CTA': '有兴趣达到',
        'Tag Available': '可用',
        'Tag Marketplace': '市场',
        'Tag Featured': '特色',
        'Expertise Heading': '我们的专业知识',
        'Expertise 1': '全球业务范围',
        'Expertise 2': '安全and可靠的导航',
        'Expertise 3': '专家维护的船队',
        'Expertise 4': '高素质的海洋专业人士',
        'Inquiry Heading': '询问此服务',
        'Inquiry Btn': '获取查询',
        'Show More': '显示更多',
        'Show Less': '显示更少',
        'Label Portharcourt': 'No. 58 Circular Road, Alcon Road, Woji, Obio-Akpor LGA, Rivers State.',
        'CAC Registration': 'RC: 9257242 - 在企业事务委员会 (CAC) 注册',
        'General Message Error': '发送消息失败。请稍后重试。',
        'Team Info Heading': '我们的领导力',
        'Meet the Team': '认识团队',
        'Lang English': 'English',
        'Lang Spanish': 'Español',
        'Lang French': 'Français',
        'Lang German': 'Deutsch',
        'Lang Chinese': '中文 (Chinese)',
        'Delete': '删除',
        'Administrator': '管理员',
        'Headquarters': '总部',
        'Messages': '消息',
        'Manage Messages': '查看并管理收到的消息',
        'No Messages': '未找到消息。',
        'View Message': '查看消息',
        'Mark as Read': '标记为已读',
        'Mark as Unread': '标记为未读',
        'No Subject': '无主题',
        'Received Date': '接收日期',
        'Error Label': '错误',
        'Try Refresh': '刷新',
        'Files Selected': '选定的文件',
        'NA': '不适用',
        'Mass Delete Confirm': '您确定要删除这些项目吗?',
        'Delete Success': '项目已成功删除',
        'Form Required Error': '标题和描述是必需的',
        'FAQ Required Error': '问题和答案是必需的',
        'Marketplace Empty State': '添加市场商品后，它们将显示在此处。',
        'FAQ Empty State': '找不到常见问题。添加一个以开始。',
        'Newsletter Empty State': '找不到订阅者。',
        'File Size Error': '文件太大'
    }

};
